import React, { useEffect, useMemo, useState } from "react";

const BRAND = {
  name: "Experiencia Nila",
  subtitle: "Nación Nila Estética",
  address:
    "Centro Comercial Santa María Este, Local #35, Santa Ana, Costa Rica",
  phone: "6064-0414",
  instagram: "@nila_estetic",
  instagramUrl: "https://www.instagram.com/nila_estetic/",
  facebook: "Nación Nila Estética",
  facebookUrl: "https://www.facebook.com/nacionnilaestetica/",
  website: "nacionnila.com",
  websiteUrl: "https://nacionnila.com",
  mission:
    "Brindar tratamientos estéticos personalizados con una experiencia elegante, segura y centrada en el bienestar integral de cada cliente.",
};

// USUARIO ADMIN FIJO
const ADMIN_USER = {
  id: "admin1",
  nombreCompleto: "Administrador",
  username: "admin",
  password: "admin",
  role: "owner",
  pin: "0000",
  label: "Owner",
  activo: true,
};

function saveLS(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}
function loadLS(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function loadUsers() {
  const saved = loadLS("nila_users", null);
  if (saved && saved.length > 0) {
    const hasAdmin = saved.some((u) => u.username === "admin");
    if (!hasAdmin) return [ADMIN_USER, ...saved];
    return saved;
  }
  return [ADMIN_USER];
}

const bodyCategories = ["Moldeo corporal", "Depilación láser", "Masajes"];
const medicalOptions = [
  "Embarazo",
  "Diabetes",
  "Enfermedades autoinmunes",
  "Rosácea",
  "Asma",
  "Hipertensión",
  "Poros dilatados",
  "Epilepsia o convulsiones",
  "Alergias en la piel",
  "Cardiopatía",
  "Daño solar",
  "Enfermedades de ETS",
];
const treatmentProcedureText =
  "El tratamiento consiste en un procedimiento estético personalizado según la necesidad del paciente. Su objetivo es estético y no tiene finalidad médica curativa.";
const consentBody = `Información importante sobre el tratamiento:

• En cada sesión se aplicará una técnica diferente según el protocolo y la necesidad del paciente.
• El paciente debe presentarse puntualmente a cada cita.
• En caso de no poder asistir, debe avisar con al menos 24/12 horas de anticipación.
• El tratamiento tiene vencimiento y no es transferible a terceras personas.

Riesgos y efectos secundarios:
• Enrojecimiento temporal, inflamación o dolor localizado.
• Aparición de hematomas o moretones.
• Reacciones alérgicas o infecciones en casos excepcionales.

Recomendaciones generales:
• Seguir indicaciones pre y post tratamiento dadas por el profesional.
• Para tratamientos faciales: no exponerse al sol sin protección, usar bloqueador solar y seguir las recomendaciones indicadas por el centro.

Declaración del cliente:
Declaro que he recibido información clara, suficiente y comprensible sobre el procedimiento estético a realizar, sus beneficios esperados, posibles riesgos, reacciones secundarias, contraindicaciones y cuidados. Comprendo que los resultados pueden variar según mis características individuales y que este procedimiento es de carácter estético y no sustituye diagnósticos ni tratamientos médicos.`;

const initialForm = {
  treatmentType: "",
  bodyCategory: "",
  moldeoText: "",
  laserText: "",
  massageText: "",
  facialText: "",
  nombre: "",
  cedula: "",
  fechaNacimiento: "",
  edad: "",
  genero: "",
  direccion: "",
  profesion: "",
  correo: "",
  telefono: "",
  emergenciaNombre: "",
  emergenciaTelefono: "",
  emergenciaCorreo: "",
  emergenciaRelacion: "",
  objetivos: "",
  medical: [],
  medicamentosActuales: "",
  medicamentosCuales: "",
  anticonceptivos: "",
  anticonceptivosCuales: "",
  tipoPiel: "",
  alergiasProductos: "",
  procedimientosRecientes: "",
  procedimientosRecientesCuales: "",
  otrasPreocupaciones: "",
  autorizaImagen: "",
  aceptaConsentimiento: false,
  firmaCliente: "",
};

// PALETA DE COLORES LUXURY
const colors = {
  gold: {
    primary: "#C5A028",
    secondary: "#D4AF37",
    dark: "#B8860B",
    light: "#F5E6C4",
    soft: "#FDF8F0",
  },
  dark: {
    primary: "#1A1A1A",
    secondary: "#2C2C2C",
    light: "#3A3A3A",
    card: "#2A2A2A",
  },
  light: {
    primary: "#FEF9F0",
    secondary: "#FFF8F0",
    card: "#FFFFFF",
    background: "#F5F0E8",
  },
  accent: {
    success: "#2C5F4A",
    successLight: "#E8F3EF",
    warning: "#F5A623",
    danger: "#B84C3C",
  },
  gray: {
    warm: "#E8E0D5",
    medium: "#D4C9B8",
    text: "#4A4A4A",
    light: "#F5F0E8",
  },
};

const styles = {
  container: {
    minHeight: "100vh",
    background: `linear-gradient(135deg, ${colors.light.background} 0%, ${colors.gray.warm} 100%)`,
    padding: "2rem",
    position: "relative",
  },
  card: {
    backgroundColor: colors.light.card,
    borderRadius: "1.5rem",
    boxShadow:
      "0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(197, 160, 40, 0.15)",
    border: `1px solid ${colors.gold.light}`,
    padding: "2rem",
  },
  luxuryCard: {
    backgroundColor: colors.light.card,
    borderRadius: "2rem",
    boxShadow:
      "0 30px 60px -15px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(197, 160, 40, 0.2)",
    border: `1px solid ${colors.gold.secondary}`,
    padding: "2rem",
  },
  input: {
    width: "100%",
    borderRadius: "0.75rem",
    border: `1px solid ${colors.gray.medium}`,
    padding: "0.75rem 1rem",
    fontSize: "1rem",
    outline: "none",
    backgroundColor: colors.light.card,
    transition: "all 0.2s ease",
    ":focus": {
      borderColor: colors.gold.primary,
      boxShadow: `0 0 0 3px ${colors.gold.light}`,
    },
  },
  textarea: {
    width: "100%",
    borderRadius: "0.75rem",
    border: `1px solid ${colors.gray.medium}`,
    padding: "0.75rem 1rem",
    fontSize: "1rem",
    outline: "none",
    fontFamily: "inherit",
    resize: "vertical",
    backgroundColor: colors.light.card,
  },
  button: {
    backgroundColor: colors.gold.primary,
    color: colors.light.primary,
    padding: "0.75rem 1.5rem",
    borderRadius: "2rem",
    border: "none",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 8px rgba(197, 160, 40, 0.3)",
    ":hover": {
      backgroundColor: colors.gold.dark,
      transform: "translateY(-1px)",
    },
  },
  buttonSecondary: {
    backgroundColor: colors.dark.primary,
    color: colors.gold.secondary,
    padding: "0.75rem 1.5rem",
    borderRadius: "2rem",
    border: `1px solid ${colors.gold.secondary}`,
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
  },
  buttonSuccess: {
    backgroundColor: colors.accent.success,
    color: "white",
    padding: "0.75rem 1.5rem",
    borderRadius: "2rem",
    border: "none",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
  },
  buttonOutline: {
    backgroundColor: "transparent",
    color: colors.dark.primary,
    padding: "0.75rem 1.5rem",
    borderRadius: "2rem",
    border: `1px solid ${colors.gold.primary}`,
    cursor: "pointer",
    fontSize: "1rem",
  },
  buttonDanger: {
    backgroundColor: colors.accent.danger,
    color: "white",
    padding: "0.5rem 1rem",
    borderRadius: "1.5rem",
    border: "none",
    cursor: "pointer",
    fontSize: "0.75rem",
    fontWeight: "500",
  },
  buttonWarning: {
    backgroundColor: colors.accent.warning,
    color: "white",
    padding: "0.75rem 1.5rem",
    borderRadius: "2rem",
    border: "none",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
  },
  errorBox: {
    backgroundColor: colors.accent.successLight,
    border: `1px solid ${colors.accent.danger}`,
    borderRadius: "1rem",
    padding: "1rem",
    marginBottom: "1rem",
    color: colors.accent.danger,
  },
  sectionHeader: {
    fontSize: "1.25rem",
    fontWeight: "500",
    color: colors.gold.dark,
    borderBottom: `2px solid ${colors.gold.secondary}`,
    paddingBottom: "0.5rem",
    marginBottom: "1rem",
    marginTop: "1.5rem",
    letterSpacing: "0.5px",
  },
  infoRow: {
    display: "flex",
    padding: "0.75rem 0",
    borderBottom: `1px solid ${colors.gray.warm}`,
  },
  infoLabel: { width: "180px", fontWeight: "500", color: colors.gold.dark },
  infoValue: { flex: 1, color: colors.dark.primary, fontWeight: "400" },
  badge: {
    display: "inline-block",
    padding: "0.25rem 0.75rem",
    borderRadius: "2rem",
    fontSize: "0.75rem",
    fontWeight: "500",
  },
  badgePending: { backgroundColor: colors.gold.light, color: colors.gold.dark },
  badgeValidated: { backgroundColor: "#E8F0FE", color: "#2C5282" },
  badgeActive: {
    backgroundColor: colors.accent.successLight,
    color: colors.accent.success,
  },
  badgeCompleted: {
    backgroundColor: colors.gray.warm,
    color: colors.gray.text,
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2,1fr)",
    gap: "1rem",
  },
  noteItem: {
    backgroundColor: colors.gray.warm,
    borderRadius: "0.75rem",
    padding: "0.75rem",
    marginBottom: "0.5rem",
    borderLeft: `4px solid ${colors.gold.primary}`,
  },
  selectedTreatmentBadge: {
    backgroundColor: colors.gold.primary,
    color: "white",
    padding: "0.5rem 1rem",
    borderRadius: "2rem",
    fontSize: "0.875rem",
    fontWeight: "500",
    display: "inline-block",
    marginBottom: "1rem",
  },
  sessionItem: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0.75rem 0",
    borderBottom: `1px solid ${colors.gray.warm}`,
    flexWrap: "wrap",
    gap: "0.5rem",
  },
  exitButton: {
    position: "absolute",
    top: "1rem",
    right: "1rem",
    backgroundColor: "white",
    padding: "0.5rem 1rem",
    borderRadius: "2rem",
    border: `1px solid ${colors.gold.primary}`,
    cursor: "pointer",
    zIndex: 10,
  },
  tabButton: {
    padding: "0.5rem 1rem",
    borderRadius: "2rem",
    border: "none",
    cursor: "pointer",
    fontSize: "0.875rem",
    fontWeight: "500",
    marginRight: "0.5rem",
  },
  chartBar: {
    height: "30px",
    borderRadius: "1rem",
    background: colors.gold.primary,
    marginBottom: "0.5rem",
  },
  reportContainer: {
    marginTop: "1rem",
    padding: "1rem",
    backgroundColor: colors.gray.warm,
    borderRadius: "1rem",
  },
  printPage: {
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
    backgroundColor: "white",
    padding: "2rem",
    fontFamily: "Georgia, serif",
    pageBreakAfter: "always",
  },
  printHeader: {
    textAlign: "center",
    marginBottom: "2rem",
    borderBottom: `2px solid ${colors.gold.primary}`,
    paddingBottom: "1rem",
  },
  printTitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: colors.gold.dark,
    marginBottom: "0.5rem",
    fontFamily: "Georgia, serif",
  },
  printSubtitle: { fontSize: "0.9rem", color: colors.gray.text },
  printSection: { marginBottom: "1.5rem" },
  printSectionTitle: {
    fontSize: "1.1rem",
    fontWeight: "bold",
    color: colors.gold.dark,
    borderBottom: `1px solid ${colors.gold.primary}`,
    marginBottom: "0.75rem",
    paddingBottom: "0.25rem",
  },
  printRow: {
    display: "flex",
    padding: "0.5rem 0",
    borderBottom: "1px solid #eee",
  },
  printLabel: { width: "180px", fontWeight: "bold", color: colors.gray.text },
  printValue: { flex: 1, color: colors.dark.primary },
  printSignature: {
    marginTop: "2rem",
    paddingTop: "1rem",
    borderTop: `1px solid ${colors.gold.primary}`,
    textAlign: "center",
  },
  printConsent: {
    lineHeight: "1.5",
    fontSize: "0.85rem",
    textAlign: "justify",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  },
  modalContainer: {
    backgroundColor: "white",
    borderRadius: "1.5rem",
    padding: "2rem",
    maxWidth: "500px",
    width: "90%",
    boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
    textAlign: "center",
  },
  modalTitle: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    color: colors.gold.dark,
    marginBottom: "1rem",
  },
  modalButtons: {
    display: "flex",
    gap: "1rem",
    justifyContent: "center",
    marginTop: "1.5rem",
  },
};

function SectionTitle({ title, subtitle }) {
  return React.createElement(
    "div",
    { style: { marginBottom: "1.25rem" } },
    React.createElement(
      "h2",
      {
        style: {
          fontSize: "1.875rem",
          fontFamily: "Georgia, serif",
          marginBottom: "0.5rem",
          color: colors.gold.dark,
          fontWeight: "500",
          letterSpacing: "-0.5px",
        },
      },
      title
    ),
    subtitle &&
      React.createElement("p", { style: { color: colors.gray.text } }, subtitle)
  );
}

function formatDateCR(dateStr) {
  if (!dateStr) return "";
  const [y, m, d] = dateStr.split("-");
  return `${d}/${m}/${y}`;
}
function formatDateTime(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return `${d.toLocaleDateString("es-CR")} ${d.toLocaleTimeString("es-CR", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
}
function formatCurrency(amount) {
  return new Intl.NumberFormat("es-CR", {
    style: "currency",
    currency: "CRC",
    minimumFractionDigits: 0,
  }).format(amount);
}
function calcAge(dateStr) {
  if (!dateStr) return "";
  const birth = new Date(dateStr);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return String(age);
}
function toggleArray(value, array) {
  return array.includes(value)
    ? array.filter((x) => x !== value)
    : [...array, value];
}
function onlyNumbers(value) {
  return value.replace(/[^0-9]/g, "");
}
function isValidEmail(email) {
  return /^[^\s@]+@([^\s@]+\.)+[^\s@]+$/.test(email);
}
function hasFirstAndLastName(name) {
  return name.trim().split(/\s+/).length >= 2;
}
function isValidBirthDate(date) {
  if (!date) return true;
  const birth = new Date(date);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age <= 100;
}
function isValidBirthYear(dateStr) {
  if (!dateStr) return true;
  const year = parseInt(dateStr.split("-")[0]);
  if (isNaN(year)) return false;
  const currentYear = new Date().getFullYear();
  return (
    year >= 1900 &&
    year <= currentYear &&
    (year.toString()[0] === "1" || year.toString()[0] === "2")
  );
}

function getClientStatus(record) {
  if (record.status !== "validado")
    return { label: "Pendiente", badgeStyle: styles.badgePending, icon: "⏳" };
  if (!record.treatmentPlan)
    return { label: "Validado", badgeStyle: styles.badgeValidated, icon: "✅" };
  if (record.treatmentPlan?.status === "finalizado")
    return {
      label: "Finalizado",
      badgeStyle: styles.badgeCompleted,
      icon: "🏁",
    };
  return { label: "Activo", badgeStyle: styles.badgeActive, icon: "🟢" };
}

function getReportData(records) {
  const meses = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];
  const now = new Date();
  const clientesPorMes = [];
  for (let i = 5; i >= 0; i--) {
    const fecha = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const count = records.filter((r) => {
      const d = new Date(r.createdAt);
      return (
        d.getFullYear() === fecha.getFullYear() &&
        d.getMonth() === fecha.getMonth()
      );
    }).length;
    clientesPorMes.push({
      mes: `${meses[fecha.getMonth()]} ${fecha.getFullYear()}`,
      count,
    });
  }
  const estados = { Pendiente: 0, Validado: 0, Activo: 0, Finalizado: 0 };
  records.forEach((r) => {
    const s = getClientStatus(r).label;
    estados[s]++;
  });
  const tratamientos = { Facial: 0, Corporal: 0 };
  const corporalDetalle = {
    "Moldeo corporal": 0,
    "Depilación láser": 0,
    Masajes: 0,
  };
  records.forEach((r) => {
    if (r.form.treatmentType === "Facial") tratamientos.Facial++;
    if (r.form.treatmentType === "Corporal") {
      tratamientos.Corporal++;
      if (
        r.form.bodyCategory &&
        corporalDetalle[r.form.bodyCategory] !== undefined
      )
        corporalDetalle[r.form.bodyCategory]++;
    }
  });
  const sesionesPorEspecialista = {};
  records.forEach((r) => {
    (r.sessions || []).forEach((s) => {
      const nom = s.specialist || "Desconocido";
      sesionesPorEspecialista[nom] = (sesionesPorEspecialista[nom] || 0) + 1;
    });
  });
  return {
    clientesPorMes,
    estados,
    tratamientos,
    corporalDetalle,
    sesionesPorEspecialista,
  };
}

function Field({
  labelText,
  value,
  onChange,
  type = "text",
  inputMode,
  required,
  disabled,
  placeholder,
}) {
  return React.createElement(
    "div",
    { style: { marginBottom: "1rem" } },
    React.createElement(
      "label",
      {
        style: {
          display: "block",
          marginBottom: "0.5rem",
          fontWeight: "500",
          color: colors.gold.dark,
        },
      },
      labelText,
      required &&
        React.createElement(
          "span",
          { style: { color: colors.accent.danger, marginLeft: "0.25rem" } },
          "*"
        )
    ),
    React.createElement("input", {
      style: styles.input,
      value: value,
      onChange: (e) => onChange(e.target.value),
      type,
      inputMode,
      disabled,
      placeholder,
    })
  );
}

function TextAreaField({
  labelText,
  value,
  onChange,
  required,
  placeholder,
  rows = 3,
}) {
  return React.createElement(
    "div",
    { style: { marginBottom: "1rem" } },
    React.createElement(
      "label",
      {
        style: {
          display: "block",
          marginBottom: "0.5rem",
          fontWeight: "500",
          color: colors.gold.dark,
        },
      },
      labelText,
      required &&
        React.createElement(
          "span",
          { style: { color: colors.accent.danger, marginLeft: "0.25rem" } },
          "*"
        )
    ),
    React.createElement("textarea", {
      style: styles.textarea,
      value: value,
      onChange: (e) => onChange(e.target.value),
      placeholder,
      rows,
    })
  );
}

function DateField({ labelText, value, onChange, required }) {
  return React.createElement(
    "div",
    { style: { marginBottom: "1rem" } },
    React.createElement(
      "label",
      {
        style: {
          display: "block",
          marginBottom: "0.5rem",
          fontWeight: "500",
          color: colors.gold.dark,
        },
      },
      labelText,
      required &&
        React.createElement(
          "span",
          { style: { color: colors.accent.danger, marginLeft: "0.25rem" } },
          "*"
        )
    ),
    React.createElement("input", {
      type: "date",
      style: styles.input,
      value,
      onChange: (e) => onChange(e.target.value),
    })
  );
}

function SelectField({ labelText, value, onChange, options, required }) {
  return React.createElement(
    "div",
    { style: { marginBottom: "1rem" } },
    React.createElement(
      "label",
      {
        style: {
          display: "block",
          marginBottom: "0.5rem",
          fontWeight: "500",
          color: colors.gold.dark,
        },
      },
      labelText,
      required &&
        React.createElement(
          "span",
          { style: { color: colors.accent.danger, marginLeft: "0.25rem" } },
          "*"
        )
    ),
    React.createElement(
      "select",
      { style: styles.input, value, onChange: (e) => onChange(e.target.value) },
      options.map((opt) =>
        React.createElement(
          "option",
          { key: opt, value: opt },
          opt || "Seleccionar"
        )
      )
    )
  );
}

function WelcomeScreen({ onStart, onLoginClick }) {
  return React.createElement(
    "div",
    { style: styles.container },
    React.createElement(
      "div",
      {
        style: {
          maxWidth: "72rem",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "4rem",
          alignItems: "center",
          minHeight: "88vh",
        },
      },
      React.createElement(
        "div",
        null,
        React.createElement(
          "div",
          {
            style: {
              display: "inline-flex",
              gap: "0.5rem",
              borderRadius: "2rem",
              border: `1px solid ${colors.gold.secondary}`,
              backgroundColor: "rgba(255,255,255,0.9)",
              padding: "0.5rem 1rem",
              fontSize: "0.875rem",
              color: colors.gold.dark,
            },
          },
          "✦ Sistema de registro"
        ),
        React.createElement(
          "h1",
          {
            style: {
              fontSize: "4rem",
              fontFamily: "Georgia, serif",
              marginTop: "1.5rem",
              color: colors.dark.primary,
              fontWeight: "500",
              letterSpacing: "-0.02em",
            },
          },
          BRAND.name
        ),
        React.createElement(
          "p",
          {
            style: {
              fontSize: "1.25rem",
              color: colors.gray.text,
              marginTop: "0.5rem",
            },
          },
          BRAND.subtitle
        ),
        React.createElement(
          "p",
          {
            style: {
              color: colors.gray.text,
              maxWidth: "32rem",
              marginTop: "1rem",
              lineHeight: "1.6",
            },
          },
          BRAND.mission
        ),
        React.createElement(
          "div",
          {
            style: {
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "1rem",
              marginTop: "2rem",
            },
          },
          React.createElement(
            "div",
            {
              style: {
                backgroundColor: "rgba(255,255,255,0.8)",
                padding: "1rem",
                borderRadius: "1rem",
                border: `1px solid ${colors.gold.light}`,
              },
            },
            React.createElement(
              "div",
              { style: { fontSize: "0.875rem", color: colors.gold.dark } },
              "Dirección"
            ),
            React.createElement(
              "div",
              { style: { color: colors.dark.primary } },
              BRAND.address
            )
          ),
          React.createElement(
            "div",
            {
              style: {
                backgroundColor: "rgba(255,255,255,0.8)",
                padding: "1rem",
                borderRadius: "1rem",
                border: `1px solid ${colors.gold.light}`,
              },
            },
            React.createElement(
              "div",
              { style: { fontSize: "0.875rem", color: colors.gold.dark } },
              "Teléfono"
            ),
            React.createElement(
              "div",
              { style: { color: colors.dark.primary } },
              BRAND.phone
            )
          ),
          React.createElement(
            "a",
            {
              href: BRAND.instagramUrl,
              target: "_blank",
              style: { textDecoration: "none" },
            },
            React.createElement(
              "div",
              {
                style: {
                  backgroundColor: "rgba(255,255,255,0.8)",
                  padding: "1rem",
                  borderRadius: "1rem",
                  cursor: "pointer",
                  border: `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                { style: { fontSize: "0.875rem", color: colors.gold.dark } },
                "Instagram"
              ),
              React.createElement(
                "div",
                { style: { color: colors.gold.primary } },
                BRAND.instagram
              )
            )
          ),
          React.createElement(
            "a",
            {
              href: BRAND.facebookUrl,
              target: "_blank",
              style: { textDecoration: "none" },
            },
            React.createElement(
              "div",
              {
                style: {
                  backgroundColor: "rgba(255,255,255,0.8)",
                  padding: "1rem",
                  borderRadius: "1rem",
                  cursor: "pointer",
                  border: `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                { style: { fontSize: "0.875rem", color: colors.gold.dark } },
                "Facebook"
              ),
              React.createElement(
                "div",
                { style: { color: colors.gold.primary } },
                BRAND.facebook
              )
            )
          ),
          React.createElement(
            "a",
            {
              href: BRAND.websiteUrl,
              target: "_blank",
              style: { textDecoration: "none" },
            },
            React.createElement(
              "div",
              {
                style: {
                  backgroundColor: "rgba(255,255,255,0.8)",
                  padding: "1rem",
                  borderRadius: "1rem",
                  cursor: "pointer",
                  border: `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                { style: { fontSize: "0.875rem", color: colors.gold.dark } },
                "Sitio web"
              ),
              React.createElement(
                "div",
                { style: { color: colors.gold.primary } },
                BRAND.website
              )
            )
          )
        ),
        React.createElement(
          "div",
          { style: { display: "flex", gap: "1rem", marginTop: "2rem" } },
          React.createElement(
            "button",
            { onClick: onStart, style: styles.button },
            "Iniciar experiencia"
          ),
          React.createElement(
            "button",
            { onClick: onLoginClick, style: styles.buttonSecondary },
            "Acceso interno"
          )
        )
      ),
      React.createElement(
        "div",
        {
          style: {
            ...styles.luxuryCard,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          },
        },
        React.createElement(
          "div",
          {
            style: {
              width: "280px",
              height: "280px",
              borderRadius: "50%",
              background: `linear-gradient(135deg, ${colors.gray.warm} 0%, ${colors.gold.light} 100%)`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
              border: `2px solid ${colors.gold.secondary}`,
              marginBottom: "1.5rem",
            },
          },
          React.createElement(
            "div",
            {
              style: {
                fontSize: "3rem",
                fontWeight: "bold",
                fontFamily: "Georgia, serif",
                color: colors.gold.dark,
                letterSpacing: "2px",
                lineHeight: 1.2,
                textAlign: "center",
              },
            },
            "NACIÓN\nNILA"
          ),
          React.createElement(
            "div",
            {
              style: {
                fontSize: "1.2rem",
                fontWeight: "300",
                color: colors.gold.dark,
                marginTop: "0.5rem",
                letterSpacing: "4px",
              },
            },
            "ESTÉTICA"
          )
        ),
        React.createElement(
          "div",
          null,
          React.createElement(
            "div",
            {
              style: {
                fontSize: "0.9rem",
                color: colors.gold.dark,
                letterSpacing: "2px",
              },
            },
            "Nación Nila Estética"
          )
        )
      )
    )
  );
}

function LoginPanel({ onLogin, onBack }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [users] = useState(loadUsers);

  const handleLogin = () => {
    const user = users.find(
      (u) =>
        u.username === username && u.password === password && u.activo !== false
    );
    if (user) {
      onLogin(user);
    } else {
      setError("Credenciales inválidas");
    }
  };

  return React.createElement(
    "div",
    { style: styles.container },
    React.createElement(
      "div",
      { style: { maxWidth: "28rem", margin: "0 auto", ...styles.card } },
      React.createElement(
        "h2",
        {
          style: {
            fontSize: "1.5rem",
            marginBottom: "1rem",
            color: colors.gold.dark,
            fontFamily: "Georgia, serif",
          },
        },
        "Acceso interno"
      ),
      React.createElement(Field, {
        labelText: "Usuario",
        value: username,
        onChange: setUsername,
      }),
      React.createElement(Field, {
        labelText: "Contraseña",
        value: password,
        onChange: setPassword,
        type: "password",
      }),
      error &&
        React.createElement(
          "div",
          { style: { color: colors.accent.danger, marginBottom: "1rem" } },
          error
        ),
      React.createElement(
        "button",
        {
          onClick: handleLogin,
          style: { ...styles.button, width: "100%", marginBottom: "0.5rem" },
        },
        "Ingresar"
      ),
      React.createElement(
        "button",
        {
          onClick: onBack,
          style: { ...styles.buttonSecondary, width: "100%" },
        },
        "Volver"
      )
    )
  );
}

function ReportsPanel({ records }) {
  const data = getReportData(records);
  const maxCount = Math.max(...data.clientesPorMes.map((m) => m.count), 1);
  const maxSessions = Math.max(
    ...Object.values(data.sesionesPorEspecialista),
    1
  );

  return React.createElement(
    "div",
    null,
    React.createElement(
      "h2",
      {
        style: {
          fontSize: "1.5rem",
          fontFamily: "Georgia, serif",
          color: colors.gold.dark,
          marginBottom: "1rem",
        },
      },
      "📊 Reportes"
    ),
    React.createElement(
      "div",
      { style: styles.reportContainer },
      React.createElement(
        "h3",
        {
          style: {
            fontWeight: "500",
            marginBottom: "1rem",
            color: colors.gold.dark,
          },
        },
        "📅 Clientes por mes"
      ),
      data.clientesPorMes.map((item) =>
        React.createElement(
          "div",
          { key: item.mes, style: { marginBottom: "0.75rem" } },
          React.createElement(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "0.25rem",
              },
            },
            React.createElement("span", null, item.mes),
            React.createElement(
              "span",
              { style: { fontWeight: "bold", color: colors.gold.dark } },
              item.count
            )
          ),
          React.createElement("div", {
            style: {
              ...styles.chartBar,
              width: `${(item.count / maxCount) * 100}%`,
            },
          })
        )
      )
    ),
    React.createElement(
      "div",
      { style: styles.reportContainer, marginTop: "1rem" },
      React.createElement(
        "h3",
        {
          style: {
            fontWeight: "500",
            marginBottom: "1rem",
            color: colors.gold.dark,
          },
        },
        "📊 Distribución por estado"
      ),
      Object.entries(data.estados).map(([estado, count]) =>
        React.createElement(
          "div",
          { key: estado, style: { marginBottom: "0.75rem" } },
          React.createElement(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "0.25rem",
              },
            },
            React.createElement("span", null, estado),
            React.createElement(
              "span",
              { style: { fontWeight: "bold", color: colors.gold.dark } },
              count
            )
          ),
          React.createElement("div", {
            style: {
              ...styles.chartBar,
              width: `${(count / (records.length || 1)) * 100}%`,
              backgroundColor:
                estado === "Pendiente"
                  ? colors.gold.primary
                  : estado === "Validado"
                  ? "#2C5282"
                  : estado === "Activo"
                  ? colors.accent.success
                  : colors.gray.text,
            },
          })
        )
      )
    ),
    React.createElement(
      "div",
      { style: styles.reportContainer, marginTop: "1rem" },
      React.createElement(
        "h3",
        {
          style: {
            fontWeight: "500",
            marginBottom: "1rem",
            color: colors.gold.dark,
          },
        },
        "💆‍♀️ Tratamientos"
      ),
      React.createElement(
        "div",
        null,
        React.createElement("span", null, "Facial: "),
        React.createElement(
          "span",
          { style: { fontWeight: "bold", color: colors.gold.dark } },
          data.tratamientos.Facial
        )
      ),
      React.createElement(
        "div",
        null,
        React.createElement("span", null, "Corporal: "),
        React.createElement(
          "span",
          { style: { fontWeight: "bold", color: colors.gold.dark } },
          data.tratamientos.Corporal
        )
      ),
      React.createElement(
        "div",
        { style: { marginTop: "0.5rem" } },
        Object.entries(data.corporalDetalle).map(([cat, count]) =>
          React.createElement(
            "div",
            { key: cat },
            React.createElement("span", null, cat, ": "),
            React.createElement(
              "span",
              { style: { fontWeight: "bold", color: colors.gold.dark } },
              count
            )
          )
        )
      )
    ),
    React.createElement(
      "div",
      { style: styles.reportContainer, marginTop: "1rem" },
      React.createElement(
        "h3",
        {
          style: {
            fontWeight: "500",
            marginBottom: "1rem",
            color: colors.gold.dark,
          },
        },
        "👩‍⚕️ Sesiones por especialista"
      ),
      Object.entries(data.sesionesPorEspecialista).length === 0
        ? React.createElement("p", null, "No hay sesiones")
        : Object.entries(data.sesionesPorEspecialista).map(([nombre, count]) =>
            React.createElement(
              "div",
              { key: nombre, style: { marginBottom: "0.75rem" } },
              React.createElement(
                "div",
                {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "0.25rem",
                  },
                },
                React.createElement("span", null, nombre),
                React.createElement(
                  "span",
                  { style: { fontWeight: "bold", color: colors.gold.dark } },
                  count,
                  " sesiones"
                )
              ),
              React.createElement("div", {
                style: {
                  ...styles.chartBar,
                  width: `${(count / maxSessions) * 100}%`,
                },
              })
            )
          )
    )
  );
}

function UserManagement({ users, setUsers, currentUser }) {
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    nombreCompleto: "",
    username: "",
    role: "recepcion",
    pin: "",
  });
  const roles = [
    { value: "recepcion", label: "Recepción" },
    { value: "especialista", label: "Especialista" },
    { value: "manager", label: "Manager" },
    { value: "owner", label: "Owner" },
  ];
  const roleLabels = {
    recepcion: "Recepción",
    especialista: "Especialista",
    manager: "Manager",
    owner: "Owner",
  };

  const handleSave = () => {
    if (!formData.nombreCompleto || !formData.username)
      return alert("Complete todos los campos");
    const roleInfo = roles.find((r) => r.value === formData.role);
    const pin =
      formData.pin ||
      (formData.role === "recepcion"
        ? "1111"
        : formData.role === "especialista"
        ? "2222"
        : formData.role === "manager"
        ? "3333"
        : "4444");
    if (editingUser) {
      const updated = users.map((u) =>
        u.id === editingUser.id
          ? { ...u, ...formData, pin, label: roleInfo.label }
          : u
      );
      setUsers(updated);
      saveLS("nila_users", updated);
    } else {
      const newUser = {
        id: Date.now().toString(),
        ...formData,
        pin,
        password: "1234",
        label: roleInfo.label,
        activo: true,
      };
      setUsers([...users, newUser]);
      saveLS("nila_users", [...users, newUser]);
    }
    setShowForm(false);
    setEditingUser(null);
    setFormData({
      nombreCompleto: "",
      username: "",
      role: "recepcion",
      pin: "",
    });
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setFormData({
      nombreCompleto: user.nombreCompleto,
      username: user.username,
      role: user.role,
      pin: user.pin,
    });
    setShowForm(true);
  };
  const handleDelete = (user) => {
    if (user.username === "admin")
      return alert("No se puede desactivar al administrador principal");
    if (window.confirm(`¿Desactivar a ${user.nombreCompleto}?`)) {
      const updated = users.map((u) =>
        u.id === user.id ? { ...u, activo: false } : u
      );
      setUsers(updated);
      saveLS("nila_users", updated);
    }
  };
  const handleReset = (user) => {
    if (
      window.confirm(`Resetear contraseña de ${user.nombreCompleto} a "1234"?`)
    ) {
      const updated = users.map((u) =>
        u.id === user.id ? { ...u, password: "1234" } : u
      );
      setUsers(updated);
      saveLS("nila_users", updated);
    }
  };

  const activeUsers = users.filter((u) => u.activo !== false);

  return React.createElement(
    "div",
    null,
    React.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "1rem",
        },
      },
      React.createElement(
        "h2",
        {
          style: {
            fontSize: "1.5rem",
            color: colors.gold.dark,
            fontFamily: "Georgia, serif",
          },
        },
        "Usuarios"
      ),
      React.createElement(
        "button",
        {
          onClick: () => {
            setEditingUser(null);
            setFormData({
              nombreCompleto: "",
              username: "",
              role: "recepcion",
              pin: "",
            });
            setShowForm(true);
          },
          style: styles.button,
        },
        "+ Nuevo"
      )
    ),
    showForm &&
      React.createElement(
        "div",
        { style: { ...styles.card, marginBottom: "1rem" } },
        React.createElement(
          "h3",
          null,
          editingUser ? "Editar Usuario" : "Nuevo Usuario"
        ),
        React.createElement(Field, {
          labelText: "Nombre completo",
          value: formData.nombreCompleto,
          onChange: (v) => setFormData({ ...formData, nombreCompleto: v }),
        }),
        React.createElement(Field, {
          labelText: "Usuario",
          value: formData.username,
          onChange: (v) => setFormData({ ...formData, username: v }),
        }),
        React.createElement(SelectField, {
          labelText: "Rol",
          value: formData.role,
          onChange: (v) => setFormData({ ...formData, role: v }),
          options: roles.map((r) => r.value),
        }),
        React.createElement(Field, {
          labelText: "PIN (opcional)",
          value: formData.pin,
          onChange: (v) =>
            setFormData({ ...formData, pin: onlyNumbers(v).slice(0, 4) }),
          placeholder: "4 dígitos",
        }),
        React.createElement(
          "div",
          {
            style: {
              display: "flex",
              gap: "1rem",
              justifyContent: "flex-end",
              marginTop: "1rem",
            },
          },
          React.createElement(
            "button",
            {
              onClick: () => {
                setShowForm(false);
                setEditingUser(null);
              },
              style: styles.buttonOutline,
            },
            "Cancelar"
          ),
          React.createElement(
            "button",
            { onClick: handleSave, style: styles.buttonSuccess },
            "Guardar"
          )
        )
      ),
    React.createElement(
      "div",
      { style: styles.card },
      React.createElement(
        "table",
        { style: { width: "100%", borderCollapse: "collapse" } },
        React.createElement(
          "thead",
          null,
          React.createElement(
            "tr",
            { style: { borderBottom: `2px solid ${colors.gold.primary}` } },
            React.createElement(
              "th",
              {
                style: {
                  textAlign: "left",
                  padding: "0.75rem",
                  color: colors.gold.dark,
                },
              },
              "Nombre"
            ),
            React.createElement(
              "th",
              {
                style: {
                  textAlign: "left",
                  padding: "0.75rem",
                  color: colors.gold.dark,
                },
              },
              "Usuario"
            ),
            React.createElement(
              "th",
              {
                style: {
                  textAlign: "left",
                  padding: "0.75rem",
                  color: colors.gold.dark,
                },
              },
              "Rol"
            ),
            React.createElement(
              "th",
              {
                style: {
                  textAlign: "left",
                  padding: "0.75rem",
                  color: colors.gold.dark,
                },
              },
              "Acciones"
            )
          )
        ),
        React.createElement(
          "tbody",
          null,
          activeUsers.map((user) =>
            React.createElement(
              "tr",
              {
                key: user.id,
                style: { borderBottom: `1px solid ${colors.gray.warm}` },
              },
              React.createElement(
                "td",
                { style: { padding: "0.75rem" } },
                user.nombreCompleto
              ),
              React.createElement(
                "td",
                { style: { padding: "0.75rem" } },
                user.username
              ),
              React.createElement(
                "td",
                { style: { padding: "0.75rem" } },
                roleLabels[user.role] || user.label
              ),
              React.createElement(
                "td",
                { style: { padding: "0.75rem" } },
                React.createElement(
                  "button",
                  {
                    onClick: () => handleEdit(user),
                    style: {
                      ...styles.buttonOutline,
                      padding: "0.25rem 0.5rem",
                      fontSize: "0.75rem",
                      marginRight: "0.5rem",
                    },
                  },
                  "Editar"
                ),
                user.username !== "admin" &&
                  React.createElement(
                    "button",
                    {
                      onClick: () => handleReset(user),
                      style: {
                        ...styles.buttonOutline,
                        padding: "0.25rem 0.5rem",
                        fontSize: "0.75rem",
                        marginRight: "0.5rem",
                      },
                    },
                    "Reset"
                  ),
                user.username !== "admin" &&
                  React.createElement(
                    "button",
                    {
                      onClick: () => handleDelete(user),
                      style: styles.buttonDanger,
                    },
                    "Desactivar"
                  )
              )
            )
          )
        )
      )
    )
  );
}

// Componente para imprimir el formulario (2 páginas)
function PrintForm({ record, onClose }) {
  const form = record.form;
  const fechaRegistro = formatDateCR(record.createdAt?.slice(0, 10));

  const condicionesMedicas = form.medical?.join(", ") || "Ninguna";

  let tratamientoDetalle = "";
  if (form.treatmentType === "Facial") {
    tratamientoDetalle = form.facialText || "No especificado";
  } else if (form.treatmentType === "Corporal") {
    if (form.bodyCategory === "Moldeo corporal") {
      tratamientoDetalle = `Moldeo corporal: ${
        form.moldeoText || "No especificado"
      }`;
    } else if (form.bodyCategory === "Depilación láser") {
      tratamientoDetalle = `Depilación láser: ${
        form.laserText || "No especificado"
      }`;
    } else if (form.bodyCategory === "Masajes") {
      tratamientoDetalle = `Masajes: ${form.massageText || "No especificado"}`;
    } else {
      tratamientoDetalle = form.bodyCategory || "No seleccionado";
    }
  }

  return React.createElement(
    "div",
    {
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 2000,
        overflow: "auto",
        padding: "2rem",
      },
    },
    React.createElement(
      "div",
      {
        style: {
          maxWidth: "900px",
          margin: "0 auto",
          backgroundColor: "white",
          borderRadius: "1rem",
          boxShadow: "0 25px 50px rgba(0,0,0,0.3)",
        },
      },
      React.createElement(
        "div",
        {
          style: {
            padding: "1rem",
            borderBottom: "1px solid #eee",
            display: "flex",
            justifyContent: "flex-end",
          },
        },
        React.createElement(
          "button",
          {
            onClick: onClose,
            style: { ...styles.buttonDanger, padding: "0.5rem 1rem" },
          },
          "Cerrar"
        ),
        React.createElement(
          "button",
          {
            onClick: () => window.print(),
            style: {
              ...styles.button,
              marginLeft: "1rem",
              padding: "0.5rem 1rem",
            },
          },
          "🖨️ Imprimir"
        )
      ),

      // PÁGINA 1: Información del cliente
      React.createElement(
        "div",
        { style: { ...styles.printPage, pageBreakAfter: "always" } },
        React.createElement(
          "div",
          { style: styles.printHeader },
          React.createElement("div", { style: styles.printTitle }, BRAND.name),
          React.createElement(
            "div",
            { style: styles.printSubtitle },
            BRAND.subtitle
          ),
          React.createElement(
            "div",
            { style: styles.printSubtitle },
            "Fecha de registro: ",
            fechaRegistro
          )
        ),

        React.createElement(
          "div",
          { style: styles.printSection },
          React.createElement(
            "div",
            { style: styles.printSectionTitle },
            "📋 INFORMACIÓN PERSONAL"
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Nombre completo:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.nombre || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement("div", { style: styles.printLabel }, "Cédula:"),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.cedula || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Fecha de nacimiento:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              formatDateCR(form.fechaNacimiento) || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement("div", { style: styles.printLabel }, "Edad:"),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.edad || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement("div", { style: styles.printLabel }, "Género:"),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.genero || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Teléfono:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.telefono || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Correo electrónico:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.correo || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Profesión:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.profesion || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Dirección:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.direccion || "—"
            )
          )
        ),

        React.createElement(
          "div",
          { style: styles.printSection },
          React.createElement(
            "div",
            { style: styles.printSectionTitle },
            "🚨 CONTACTO DE EMERGENCIA"
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement("div", { style: styles.printLabel }, "Nombre:"),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.emergenciaNombre || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Teléfono:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.emergenciaTelefono || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Correo electrónico:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.emergenciaCorreo || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Relación:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.emergenciaRelacion || "—"
            )
          )
        ),

        React.createElement(
          "div",
          { style: styles.printSection },
          React.createElement(
            "div",
            { style: styles.printSectionTitle },
            "💆‍♀️ TRATAMIENTO SELECCIONADO"
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Tipo de tratamiento:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.treatmentType || "No seleccionado"
            )
          ),
          form.bodyCategory &&
            React.createElement(
              "div",
              { style: styles.printRow },
              React.createElement(
                "div",
                { style: styles.printLabel },
                "Categoría corporal:"
              ),
              React.createElement(
                "div",
                { style: styles.printValue },
                form.bodyCategory
              )
            ),
          tratamientoDetalle &&
            React.createElement(
              "div",
              { style: styles.printRow },
              React.createElement(
                "div",
                { style: styles.printLabel },
                "Detalle:"
              ),
              React.createElement(
                "div",
                { style: styles.printValue },
                tratamientoDetalle
              )
            )
        ),

        React.createElement(
          "div",
          { style: styles.printSection },
          React.createElement(
            "div",
            { style: styles.printSectionTitle },
            "🩺 INFORMACIÓN MÉDICA"
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Condiciones médicas:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              condicionesMedicas
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Medicamentos actuales:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.medicamentosActuales || "No especifica"
            )
          ),
          form.medicamentosActuales === "Sí" &&
            React.createElement(
              "div",
              { style: styles.printRow },
              React.createElement(
                "div",
                { style: styles.printLabel },
                "¿Cuáles?"
              ),
              React.createElement(
                "div",
                { style: styles.printValue },
                form.medicamentosCuales || "—"
              )
            ),
          form.genero === "Femenino" &&
            React.createElement(
              "div",
              { style: styles.printRow },
              React.createElement(
                "div",
                { style: styles.printLabel },
                "Anticonceptivos:"
              ),
              React.createElement(
                "div",
                { style: styles.printValue },
                form.anticonceptivos || "No especifica"
              )
            ),
          form.genero === "Femenino" &&
            form.anticonceptivos === "Sí" &&
            React.createElement(
              "div",
              { style: styles.printRow },
              React.createElement(
                "div",
                { style: styles.printLabel },
                "¿Qué tipo?"
              ),
              React.createElement(
                "div",
                { style: styles.printValue },
                form.anticonceptivosCuales || "—"
              )
            ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Tipo de piel:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.tipoPiel || "No especifica"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Alergias:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.alergiasProductos || "Ninguna"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Procedimientos estéticos recientes:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.procedimientosRecientes || "No"
            )
          ),
          form.procedimientosRecientes === "Sí" &&
            React.createElement(
              "div",
              { style: styles.printRow },
              React.createElement(
                "div",
                { style: styles.printLabel },
                "¿Cuáles?"
              ),
              React.createElement(
                "div",
                { style: styles.printValue },
                form.procedimientosRecientesCuales || "—"
              )
            ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Autoriza uso de imagen:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.autorizaImagen === "Sí"
                ? "✓ Sí"
                : form.autorizaImagen === "No"
                ? "✗ No"
                : "No especifica"
            )
          )
        ),

        React.createElement(
          "div",
          { style: styles.printSection },
          React.createElement(
            "div",
            { style: styles.printSectionTitle },
            "✍️ FIRMA"
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Firma del cliente:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.firmaCliente || "No firmado"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printSignature },
            "_________________________",
            React.createElement("br", null),
            "Firma del cliente"
          )
        )
      ),

      // PÁGINA 2: Consentimiento informado
      React.createElement(
        "div",
        { style: { ...styles.printPage, pageBreakAfter: "always" } },
        React.createElement(
          "div",
          { style: styles.printHeader },
          React.createElement(
            "div",
            { style: styles.printTitle },
            "CONSENTIMIENTO INFORMADO"
          ),
          React.createElement(
            "div",
            { style: styles.printSubtitle },
            BRAND.name
          ),
          React.createElement(
            "div",
            { style: styles.printSubtitle },
            "Fecha: ",
            fechaRegistro
          )
        ),
        React.createElement(
          "div",
          { style: styles.printConsent },
          React.createElement(
            "div",
            {
              style: {
                fontWeight: "bold",
                marginBottom: "0.5rem",
                color: colors.gold.dark,
              },
            },
            "Procedimiento"
          ),
          React.createElement(
            "div",
            { style: { marginBottom: "1rem" } },
            treatmentProcedureText
          ),
          consentBody.split("\n").map((line, i) => {
            if (
              line.startsWith("Información importante") ||
              line.startsWith("Riesgos") ||
              line.startsWith("Recomendaciones") ||
              line.startsWith("Declaración")
            ) {
              return React.createElement(
                "div",
                {
                  key: i,
                  style: {
                    fontWeight: "bold",
                    marginTop: "0.75rem",
                    marginBottom: "0.25rem",
                    color: colors.gold.dark,
                  },
                },
                line
              );
            }
            if (line.trim() === "")
              return React.createElement("div", {
                key: i,
                style: { height: "0.5rem" },
              });
            return React.createElement("div", { key: i }, line);
          })
        ),
        React.createElement(
          "div",
          { style: styles.printSignature },
          React.createElement("div", null, "_______________________________"),
          React.createElement("div", null, "Firma del cliente"),
          React.createElement(
            "div",
            { style: { marginTop: "1rem" } },
            "_______________________________"
          ),
          React.createElement("div", null, "Firma del especialista")
        )
      )
    )
  );
}

function InfoRow({ label, value }) {
  return React.createElement(
    "div",
    { style: styles.infoRow },
    React.createElement("div", { style: styles.infoLabel }, label, ":"),
    React.createElement("div", { style: styles.infoValue }, value || "—")
  );
}

// Componente Modal para preguntar IVA
function IvaModal({ onClose, onConfirm, title, message }) {
  return React.createElement(
    "div",
    { style: styles.modalOverlay },
    React.createElement(
      "div",
      { style: styles.modalContainer },
      React.createElement(
        "div",
        { style: styles.modalTitle },
        title || "¿El precio incluye IVA?"
      ),
      React.createElement(
        "p",
        { style: { marginBottom: "1rem", color: colors.gray.text } },
        message || "Seleccione una opción:"
      ),
      React.createElement(
        "div",
        { style: styles.modalButtons },
        React.createElement(
          "button",
          {
            onClick: () => onConfirm(true),
            style: { ...styles.buttonSuccess, padding: "0.5rem 1rem" },
          },
          "✓ Sí, incluye IVA"
        ),
        React.createElement(
          "button",
          {
            onClick: () => onConfirm(false),
            style: { ...styles.buttonDanger, padding: "0.5rem 1rem" },
          },
          "✗ No, no incluye IVA"
        )
      )
    )
  );
}

function RecordDetailView({ user, record, onUpdate }) {
  const [newNote, setNewNote] = useState("");
  const [showPrint, setShowPrint] = useState(false);
  const [showIvaModal, setShowIvaModal] = useState(false);
  const [pendingAddSessionsData, setPendingAddSessionsData] = useState(null);
  const canValidate = ["especialista", "manager", "owner"].includes(user.role);
  const canCreateTreatment = ["especialista", "manager", "owner"].includes(
    user.role
  );
  const canRegisterSession = ["especialista", "manager", "owner"].includes(
    user.role
  );
  const canAddSessions = ["especialista", "manager", "owner"].includes(
    user.role
  );
  const canFinalize = ["especialista", "manager", "owner"].includes(user.role);

  const isRecordValidated = record.status === "validado";
  const hasTreatment = !!record.treatmentPlan;
  const isCompleted = record.treatmentPlan?.remainingSessions === 0;
  const isFinalized = record.treatmentPlan?.status === "finalizado";

  const handleValidate = () =>
    onUpdate({
      ...record,
      status: "validado",
      specialistReview: {
        specialistName: user.nombreCompleto,
        signedAt: new Date().toISOString(),
      },
    });

  const handleCreateTreatment = () => {
    const totalSessions = prompt("Total de sesiones", "5");
    if (!totalSessions) return;

    const treatmentName = prompt(
      "Nombre del tratamiento",
      record.form.bodyCategory || record.form.treatmentType || "Tratamiento"
    );
    if (!treatmentName) return;

    const packagePrice = prompt("Precio total del paquete (₡)", "0");
    if (packagePrice === null) return;

    const handleIvaResponse = (ivaIncluded) => {
      const priceNum = parseFloat(packagePrice) || 0;
      let ivaAmount = 0;
      let finalPrice = priceNum;

      if (!ivaIncluded) {
        ivaAmount = priceNum * 0.13;
        finalPrice = priceNum + ivaAmount;
      }

      onUpdate({
        ...record,
        treatmentPlan: {
          name: treatmentName,
          totalSessions: parseInt(totalSessions),
          completedSessions: 0,
          remainingSessions: parseInt(totalSessions),
          startDate: new Date().toISOString().slice(0, 10),
          status: "activo",
          sessionAdditions: [],
          packagePrice: priceNum,
          ivaAmount: ivaAmount,
          ivaIncluded: ivaIncluded,
          totalPrice: finalPrice,
        },
      });

      alert(
        `💰 TRATAMIENTO CREADO\n\n📦 Precio del paquete: ${formatCurrency(
          priceNum
        )}\n📋 IVA (13%): ${
          ivaIncluded ? "Incluido en el precio" : formatCurrency(ivaAmount)
        }\n💰 Total a pagar: ${formatCurrency(
          finalPrice
        )}\n\n📅 Sesiones: ${totalSessions}\n💆‍♀️ Tratamiento: ${treatmentName}`
      );
      setShowIvaModal(false);
    };

    setShowIvaModal(true);
    window.tempIvaCallback = handleIvaResponse;
  };

  const handleFinalize = () => {
    if (window.confirm(`¿Finalizar tratamiento?`)) {
      onUpdate({
        ...record,
        treatmentPlan: { ...record.treatmentPlan, status: "finalizado" },
      });
      alert("✅ Tratamiento finalizado");
    }
  };

  const handleRegisterSession = () => {
    if (!isRecordValidated) return alert("❌ Expediente debe estar validado");
    if (!hasTreatment) return alert("❌ No hay plan de tratamiento");
    if (isFinalized) return alert("❌ Tratamiento ya finalizado");
    const completed = record.treatmentPlan.completedSessions || 0;
    const total = record.treatmentPlan.totalSessions;
    if (completed >= total) return alert("❌ No hay más sesiones");
    const nextNum = completed + 1;
    const isLast = nextNum === total;
    const newSessions = [
      ...(record.sessions || []),
      {
        number: nextNum,
        date: new Date().toISOString().slice(0, 10),
        specialist: user.nombreCompleto,
      },
    ];
    onUpdate({
      ...record,
      sessions: newSessions,
      treatmentPlan: {
        ...record.treatmentPlan,
        completedSessions: completed + 1,
        remainingSessions: total - (completed + 1),
        status: isLast ? "completado" : "activo",
      },
    });
    alert(
      isLast
        ? `✅ Sesión ${nextNum} registrada.\n👉 Use "Finalizar" para completar`
        : `✅ Sesión ${nextNum} registrada. Restan ${total - (completed + 1)}`
    );
  };

  const startAddSessions = () => {
    const additionalSessionsInput = prompt(
      "Número de sesiones adicionales",
      "1"
    );
    if (!additionalSessionsInput) return;
    const additionalSessions = parseInt(additionalSessionsInput);
    if (isNaN(additionalSessions) || additionalSessions <= 0) {
      alert("Por favor ingrese un número válido de sesiones");
      return;
    }

    const additionalPriceInput = prompt(
      "Precio de las sesiones adicionales (₡)",
      "0"
    );
    if (additionalPriceInput === null) return;
    const additionalPrice = parseFloat(additionalPriceInput) || 0;

    const reason = prompt(
      "Motivo de la adición de sesiones:",
      "Cliente solicitó sesiones adicionales"
    );
    if (!reason) return;

    setPendingAddSessionsData({ additionalSessions, additionalPrice, reason });
    setShowIvaModal(true);
  };

  const handleAddSessionsWithIva = (ivaIncluded) => {
    if (!pendingAddSessionsData) return;

    const { additionalSessions, additionalPrice, reason } =
      pendingAddSessionsData;

    let additionalIva = 0;
    let additionalTotal = additionalPrice;
    if (!ivaIncluded) {
      additionalIva = additionalPrice * 0.13;
      additionalTotal = additionalPrice + additionalIva;
    }

    const currentTotalSessions = record.treatmentPlan.totalSessions;
    const currentCompleted = record.treatmentPlan.completedSessions || 0;
    const currentRemaining = record.treatmentPlan.remainingSessions;
    const currentPackagePrice = record.treatmentPlan.packagePrice || 0;
    const currentIvaAmount = record.treatmentPlan.ivaAmount || 0;
    const currentTotalPrice = record.treatmentPlan.totalPrice || 0;

    const newTotalSessions = currentTotalSessions + additionalSessions;
    const newRemaining = currentRemaining + additionalSessions;
    const newPackagePrice = currentPackagePrice + additionalPrice;
    const newIvaAmount = currentIvaAmount + additionalIva;
    const newTotalPrice = currentTotalPrice + additionalTotal;

    const additionRecord = {
      date: new Date().toISOString(),
      addedBy: user.nombreCompleto,
      additionalSessions: additionalSessions,
      additionalPrice: additionalPrice,
      additionalIva: additionalIva,
      additionalTotal: additionalTotal,
      ivaIncluded: ivaIncluded,
      reason: reason,
      previousTotalSessions: currentTotalSessions,
      newTotalSessions: newTotalSessions,
      previousPackagePrice: currentPackagePrice,
      newPackagePrice: newPackagePrice,
      previousTotalPrice: currentTotalPrice,
      newTotalPrice: newTotalPrice,
    };

    const updatedPlan = {
      ...record.treatmentPlan,
      totalSessions: newTotalSessions,
      remainingSessions: newRemaining,
      status: "activo",
      packagePrice: newPackagePrice,
      ivaAmount: newIvaAmount,
      totalPrice: newTotalPrice,
      sessionAdditions: [
        ...(record.treatmentPlan.sessionAdditions || []),
        additionRecord,
      ],
    };

    const changeRecord = {
      field: "sesiones y precio",
      before: `${currentTotalSessions} sesiones · ${formatCurrency(
        currentPackagePrice
      )}`,
      after: `${newTotalSessions} sesiones · ${formatCurrency(
        newPackagePrice
      )}`,
      by: user.nombreCompleto,
      reason: reason,
      at: new Date().toISOString(),
    };

    const updated = {
      ...record,
      treatmentPlan: updatedPlan,
      changeHistory: [...(record.changeHistory || []), changeRecord],
    };

    onUpdate(updated);

    alert(
      `✅ SESIONES ADICIONALES AGREGADAS\n\n` +
        `📊 Sesiones: ${currentTotalSessions} → ${newTotalSessions}\n` +
        `💰 Precio original: ${formatCurrency(currentPackagePrice)}\n` +
        `💰 Nuevo precio (sesiones adicionales): ${formatCurrency(
          additionalPrice
        )}\n` +
        `📋 IVA de las adicionales: ${
          ivaIncluded ? "Incluido" : formatCurrency(additionalIva)
        }\n` +
        `💰 Nuevo total del paquete: ${formatCurrency(newPackagePrice)}\n` +
        `💰 Nuevo total con IVA: ${formatCurrency(newTotalPrice)}\n\n` +
        `📅 Sesiones restantes: ${newRemaining}\n` +
        `👤 Agregado por: ${user.nombreCompleto}\n` +
        `📝 Motivo: ${reason}`
    );

    setShowIvaModal(false);
    setPendingAddSessionsData(null);
  };

  const handleAddNote = () => {
    if (!newNote.trim()) return alert("Escriba una nota");
    onUpdate({
      ...record,
      notes: [
        ...(record.notes || []),
        {
          id: Date.now(),
          text: newNote,
          author: user.nombreCompleto,
          role: user.label,
          date: new Date().toISOString(),
        },
      ],
    });
    setNewNote("");
  };

  const status = getClientStatus(record);
  const showFinalize = isCompleted && !isFinalized && canFinalize;

  if (showIvaModal && window.tempIvaCallback) {
    return React.createElement(IvaModal, {
      onClose: () => {
        setShowIvaModal(false);
        window.tempIvaCallback = null;
      },
      onConfirm: (ivaIncluded) => {
        if (window.tempIvaCallback) {
          window.tempIvaCallback(ivaIncluded);
          window.tempIvaCallback = null;
        } else if (pendingAddSessionsData) {
          handleAddSessionsWithIva(ivaIncluded);
        }
      },
      title: "Información de IVA",
      message: "¿El precio ingresado INCLUYE el IVA? (13%)",
    });
  }

  return React.createElement(
    "div",
    null,
    React.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "1rem",
          flexWrap: "wrap",
          gap: "1rem",
        },
      },
      React.createElement(
        "div",
        null,
        React.createElement(
          "h2",
          {
            style: {
              fontSize: "1.5rem",
              fontFamily: "Georgia, serif",
              marginBottom: "0.25rem",
              color: colors.gold.dark,
            },
          },
          record.form.nombre || "Cliente"
        ),
        React.createElement(
          "span",
          { style: { ...styles.badge, ...status.badgeStyle } },
          status.icon,
          " ",
          status.label
        )
      ),
      React.createElement(
        "div",
        { style: { display: "flex", gap: "0.5rem", flexWrap: "wrap" } },
        React.createElement(
          "button",
          {
            onClick: () => setShowPrint(true),
            style: { ...styles.buttonOutline },
          },
          "🖨️ Imprimir formulario"
        ),
        canValidate &&
          record.status !== "validado" &&
          React.createElement(
            "button",
            { onClick: handleValidate, style: styles.buttonSuccess },
            "✓ Validar"
          ),
        !hasTreatment &&
          canCreateTreatment &&
          isRecordValidated &&
          React.createElement(
            "button",
            { onClick: handleCreateTreatment, style: styles.button },
            "+ Tratamiento"
          ),
        hasTreatment &&
          canRegisterSession &&
          !isFinalized &&
          React.createElement(
            "button",
            { onClick: handleRegisterSession, style: styles.button },
            `📝 Sesión (${record.treatmentPlan.completedSessions}/${record.treatmentPlan.totalSessions})`
          ),
        hasTreatment &&
          canAddSessions &&
          React.createElement(
            "button",
            { onClick: startAddSessions, style: styles.buttonWarning },
            "➕ Agregar sesiones"
          ),
        showFinalize &&
          React.createElement(
            "button",
            { onClick: handleFinalize, style: styles.buttonSuccess },
            "🏁 Finalizar"
          )
      )
    ),
    showPrint &&
      React.createElement(PrintForm, {
        record,
        onClose: () => setShowPrint(false),
      }),

    showIvaModal &&
      pendingAddSessionsData &&
      React.createElement(IvaModal, {
        onClose: () => {
          setShowIvaModal(false);
          setPendingAddSessionsData(null);
        },
        onConfirm: handleAddSessionsWithIva,
        title: "Información de IVA",
        message:
          "¿El precio ingresado para las sesiones adicionales INCLUYE el IVA? (13%)",
      }),

    record.specialistReview &&
      React.createElement(
        "div",
        {
          style: {
            backgroundColor: colors.accent.successLight,
            padding: "0.5rem",
            borderRadius: "0.5rem",
            marginBottom: "1rem",
            color: colors.accent.success,
          },
        },
        "✓ Validado por ",
        record.specialistReview.specialistName
      ),

    hasTreatment &&
      record.treatmentPlan.packagePrice !== undefined &&
      React.createElement(
        "div",
        {
          style: {
            backgroundColor: colors.gold.light,
            padding: "0.75rem",
            borderRadius: "0.5rem",
            marginBottom: "1rem",
            border: `1px solid ${colors.gold.primary}`,
          },
        },
        React.createElement(
          "div",
          {
            style: {
              fontWeight: "bold",
              marginBottom: "0.25rem",
              color: colors.gold.dark,
            },
          },
          "💰 INFORMACIÓN DE PAGO"
        ),
        React.createElement(
          "div",
          null,
          "Precio del paquete: ",
          formatCurrency(record.treatmentPlan.packagePrice)
        ),
        React.createElement(
          "div",
          null,
          "IVA (13%): ",
          record.treatmentPlan.ivaIncluded
            ? "Incluido en el precio"
            : formatCurrency(record.treatmentPlan.ivaAmount)
        ),
        React.createElement(
          "div",
          {
            style: {
              fontWeight: "bold",
              marginTop: "0.25rem",
              color: colors.gold.dark,
            },
          },
          "Total a pagar: ",
          formatCurrency(record.treatmentPlan.totalPrice)
        ),
        React.createElement(
          "div",
          null,
          "Total de sesiones: ",
          record.treatmentPlan.totalSessions
        )
      ),

    React.createElement(
      "div",
      { style: styles.sectionHeader },
      "📋 INFORMACIÓN PERSONAL"
    ),
    React.createElement(
      "div",
      { style: styles.gridContainer },
      React.createElement(InfoRow, {
        label: "Nombre completo",
        value: record.form.nombre,
      }),
      React.createElement(InfoRow, {
        label: "Cédula",
        value: record.form.cedula,
      }),
      React.createElement(InfoRow, {
        label: "Fecha de nacimiento",
        value: formatDateCR(record.form.fechaNacimiento),
      }),
      React.createElement(InfoRow, { label: "Edad", value: record.form.edad }),
      React.createElement(InfoRow, {
        label: "Género",
        value: record.form.genero,
      }),
      React.createElement(InfoRow, {
        label: "Teléfono",
        value: record.form.telefono,
      }),
      React.createElement(InfoRow, {
        label: "Correo electrónico",
        value: record.form.correo,
      }),
      React.createElement(InfoRow, {
        label: "Profesión",
        value: record.form.profesion,
      }),
      React.createElement(InfoRow, {
        label: "Dirección",
        value: record.form.direccion,
      })
    ),

    React.createElement(
      "div",
      { style: styles.sectionHeader },
      "🚨 CONTACTO DE EMERGENCIA"
    ),
    React.createElement(
      "div",
      { style: styles.gridContainer },
      React.createElement(InfoRow, {
        label: "Nombre",
        value: record.form.emergenciaNombre,
      }),
      React.createElement(InfoRow, {
        label: "Teléfono",
        value: record.form.emergenciaTelefono,
      }),
      React.createElement(InfoRow, {
        label: "Correo electrónico",
        value: record.form.emergenciaCorreo,
      }),
      React.createElement(InfoRow, {
        label: "Relación",
        value: record.form.emergenciaRelacion,
      })
    ),

    React.createElement(
      "div",
      { style: styles.sectionHeader },
      "💆‍♀️ DETALLE DEL TRATAMIENTO"
    ),
    React.createElement(
      "div",
      { style: styles.gridContainer },
      React.createElement(InfoRow, {
        label: "Tipo de tratamiento",
        value: record.form.treatmentType || "No seleccionado",
      }),
      record.form.bodyCategory &&
        React.createElement(InfoRow, {
          label: "Categoría corporal",
          value: record.form.bodyCategory,
        }),
      record.form.moldeoText &&
        React.createElement(InfoRow, {
          label: "Moldeo corporal",
          value: record.form.moldeoText,
        }),
      record.form.laserText &&
        React.createElement(InfoRow, {
          label: "Depilación láser",
          value: record.form.laserText,
        }),
      record.form.massageText &&
        React.createElement(InfoRow, {
          label: "Masajes",
          value: record.form.massageText,
        }),
      record.form.facialText &&
        React.createElement(InfoRow, {
          label: "Tratamiento facial",
          value: record.form.facialText,
        })
    ),

    React.createElement(
      "div",
      { style: styles.sectionHeader },
      "🩺 INFORMACIÓN MÉDICA"
    ),
    React.createElement(
      "div",
      { style: styles.gridContainer },
      React.createElement(InfoRow, {
        label: "Condiciones médicas",
        value: record.form.medical?.join(", ") || "Ninguna",
      }),
      React.createElement(InfoRow, {
        label: "Medicamentos actuales",
        value: record.form.medicamentosActuales || "No especifica",
      }),
      record.form.medicamentosActuales === "Sí" &&
        React.createElement(InfoRow, {
          label: "¿Cuáles?",
          value: record.form.medicamentosCuales,
        }),
      record.form.genero === "Femenino" &&
        React.createElement(InfoRow, {
          label: "Anticonceptivos",
          value: record.form.anticonceptivos || "No especifica",
        }),
      record.form.genero === "Femenino" &&
        record.form.anticonceptivos === "Sí" &&
        React.createElement(InfoRow, {
          label: "¿Qué tipo?",
          value: record.form.anticonceptivosCuales,
        }),
      React.createElement(InfoRow, {
        label: "Tipo de piel",
        value: record.form.tipoPiel || "No especifica",
      }),
      React.createElement(InfoRow, {
        label: "Alergias",
        value: record.form.alergiasProductos || "Ninguna",
      }),
      React.createElement(InfoRow, {
        label: "Procedimientos estéticos recientes",
        value: record.form.procedimientosRecientes || "No",
      }),
      record.form.procedimientosRecientes === "Sí" &&
        React.createElement(InfoRow, {
          label: "¿Cuáles?",
          value: record.form.procedimientosRecientesCuales,
        }),
      React.createElement(InfoRow, {
        label: "Otras preocupaciones",
        value: record.form.otrasPreocupaciones || "Ninguna",
      }),
      React.createElement(InfoRow, {
        label: "Autoriza uso de imagen",
        value:
          record.form.autorizaImagen === "Sí"
            ? "✓ Sí"
            : record.form.autorizaImagen === "No"
            ? "✗ No"
            : "No especifica",
      })
    ),

    React.createElement(
      "div",
      { style: styles.sectionHeader },
      "📄 CONSENTIMIENTO Y FIRMA"
    ),
    React.createElement(
      "div",
      { style: styles.gridContainer },
      React.createElement(InfoRow, {
        label: "Aceptó consentimiento",
        value: record.form.aceptaConsentimiento ? "✓ Sí" : "✗ No",
      }),
      React.createElement(InfoRow, {
        label: "Firma del cliente",
        value: record.form.firmaCliente || "No firmado",
      }),
      React.createElement(InfoRow, {
        label: "Fecha de registro",
        value: formatDateCR(record.createdAt?.slice(0, 10)),
      })
    ),

    hasTreatment &&
      React.createElement(
        React.Fragment,
        null,
        React.createElement(
          "div",
          { style: styles.sectionHeader },
          "📅 PLAN DE TRATAMIENTO"
        ),
        React.createElement(
          "div",
          { style: styles.gridContainer },
          React.createElement(InfoRow, {
            label: "Tratamiento",
            value: record.treatmentPlan.name,
          }),
          React.createElement(InfoRow, {
            label: "Fecha inicio",
            value: formatDateCR(record.treatmentPlan.startDate),
          }),
          React.createElement(InfoRow, {
            label: "Total de sesiones",
            value: String(record.treatmentPlan.totalSessions),
          }),
          React.createElement(InfoRow, {
            label: "Sesiones realizadas",
            value: String(record.treatmentPlan.completedSessions),
          }),
          React.createElement(InfoRow, {
            label: "Sesiones restantes",
            value: String(record.treatmentPlan.remainingSessions),
          }),
          React.createElement(InfoRow, {
            label: "Estado",
            value:
              record.treatmentPlan.status === "activo"
                ? "🟢 En curso"
                : record.treatmentPlan.status === "completado"
                ? "✅ Completado"
                : "🏁 Finalizado",
          })
        )
      ),

    record.sessions?.length > 0 &&
      React.createElement(
        React.Fragment,
        null,
        React.createElement(
          "div",
          { style: styles.sectionHeader },
          "📝 HISTORIAL DE SESIONES"
        ),
        React.createElement(
          "div",
          {
            style: {
              backgroundColor: colors.gray.warm,
              borderRadius: "1rem",
              padding: "1rem",
            },
          },
          record.sessions.map((s) =>
            React.createElement(
              "div",
              { key: s.number, style: styles.sessionItem },
              React.createElement("strong", null, "Sesión ", s.number),
              React.createElement("div", null, formatDateCR(s.date)),
              React.createElement(
                "div",
                { style: { color: colors.gray.text } },
                s.specialist
              )
            )
          )
        )
      ),

    React.createElement(
      "div",
      { style: styles.sectionHeader },
      "📝 NOTAS ADICIONALES"
    ),
    React.createElement(TextAreaField, {
      labelText: "Agregar nota",
      value: newNote,
      onChange: setNewNote,
      placeholder: "Observaciones importantes...",
      rows: 3,
    }),
    React.createElement(
      "button",
      {
        onClick: handleAddNote,
        style: { ...styles.button, marginTop: "0.5rem" },
      },
      "+ Agregar nota"
    ),

    record.notes?.length > 0 &&
      React.createElement(
        "div",
        { style: { marginTop: "1rem" } },
        record.notes.map((n) =>
          React.createElement(
            "div",
            { key: n.id, style: styles.noteItem },
            React.createElement(
              "strong",
              { style: { color: colors.gold.dark } },
              n.author,
              " (",
              n.role,
              ")"
            ),
            React.createElement(
              "div",
              { style: { fontSize: "0.75rem", color: colors.gray.text } },
              formatDateTime(n.date)
            ),
            React.createElement("div", null, n.text)
          )
        )
      ),

    record.changeHistory?.length > 0 &&
      ["owner", "manager"].includes(user.role) &&
      React.createElement(
        React.Fragment,
        null,
        React.createElement(
          "div",
          { style: styles.sectionHeader },
          "📜 HISTORIAL DE CAMBIOS"
        ),
        React.createElement(
          "div",
          {
            style: {
              backgroundColor: colors.gray.warm,
              borderRadius: "1rem",
              padding: "1rem",
              fontSize: "0.875rem",
            },
          },
          record.changeHistory.map((c, i) =>
            React.createElement(
              "div",
              {
                key: i,
                style: {
                  borderBottom: `1px solid ${colors.gray.warm}`,
                  padding: "0.5rem 0",
                },
              },
              React.createElement("strong", null, c.field),
              ": ",
              c.before || "—",
              " → ",
              c.after || "—",
              React.createElement("br", null),
              React.createElement(
                "span",
                { style: { color: colors.gray.text } },
                c.by,
                " · ",
                formatDateTime(c.at)
              ),
              c.reason &&
                React.createElement(
                  "div",
                  { style: { fontSize: "0.75rem" } },
                  "Motivo: ",
                  c.reason
                )
            )
          )
        )
      )
  );
}

function Dashboard({ user, records, setRecords, onLogout }) {
  const [activeTab, setActiveTab] = useState("clientes");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("todos");
  const [users, setUsers] = useState(loadUsers);

  const filteredRecords = useMemo(() => {
    let filtered = records;
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (r) =>
          r.form.nombre?.toLowerCase().includes(term) ||
          r.form.cedula?.includes(term) ||
          r.form.telefono?.includes(term)
      );
    }
    if (filterStatus !== "todos") {
      filtered = filtered.filter((r) => {
        const status = getClientStatus(r).label.toLowerCase();
        if (filterStatus === "pendientes") return status === "pendiente";
        if (filterStatus === "validados") return status === "validado";
        if (filterStatus === "activos") return status === "activo";
        if (filterStatus === "finalizados") return status === "finalizado";
        return true;
      });
    }
    return filtered;
  }, [records, searchTerm, filterStatus]);

  const stats = {
    total: records.length,
    pendientes: records.filter((r) => getClientStatus(r).label === "Pendiente")
      .length,
    validados: records.filter((r) => getClientStatus(r).label === "Validado")
      .length,
    activos: records.filter((r) => getClientStatus(r).label === "Activo")
      .length,
    finalizados: records.filter(
      (r) => getClientStatus(r).label === "Finalizado"
    ).length,
  };

  const canManageUsers = user.role === "owner" || user.role === "manager";

  return React.createElement(
    "div",
    { style: styles.container },
    React.createElement(
      "div",
      { style: { maxWidth: "72rem", margin: "0 auto" } },
      React.createElement(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1rem",
          },
        },
        React.createElement(
          "div",
          null,
          React.createElement(
            "div",
            { style: { fontSize: "0.875rem", color: colors.gold.dark } },
            user.nombreCompleto,
            " · ",
            user.label
          ),
          React.createElement(
            "h1",
            {
              style: {
                fontSize: "2rem",
                fontFamily: "Georgia, serif",
                color: colors.gold.dark,
              },
            },
            "Panel ",
            BRAND.name
          )
        ),
        React.createElement(
          "button",
          { onClick: onLogout, style: styles.buttonSecondary },
          "Salir"
        )
      ),
      React.createElement(
        "div",
        {
          style: {
            display: "flex",
            gap: "1rem",
            marginBottom: "1rem",
            borderBottom: `1px solid ${colors.gold.light}`,
          },
        },
        React.createElement(
          "button",
          {
            onClick: () => setActiveTab("clientes"),
            style: {
              ...styles.tabButton,
              backgroundColor:
                activeTab === "clientes" ? colors.gold.primary : "transparent",
              color: activeTab === "clientes" ? "white" : colors.gold.dark,
            },
          },
          "📋 Clientes"
        ),
        React.createElement(
          "button",
          {
            onClick: () => setActiveTab("reportes"),
            style: {
              ...styles.tabButton,
              backgroundColor:
                activeTab === "reportes" ? colors.gold.primary : "transparent",
              color: activeTab === "reportes" ? "white" : colors.gold.dark,
            },
          },
          "📊 Reportes"
        ),
        canManageUsers &&
          React.createElement(
            "button",
            {
              onClick: () => setActiveTab("usuarios"),
              style: {
                ...styles.tabButton,
                backgroundColor:
                  activeTab === "usuarios"
                    ? colors.gold.primary
                    : "transparent",
                color: activeTab === "usuarios" ? "white" : colors.gold.dark,
              },
            },
            "👥 Usuarios"
          )
      ),
      activeTab === "clientes" &&
        React.createElement(
          "div",
          null,
          React.createElement(
            "div",
            {
              style: {
                display: "grid",
                gridTemplateColumns: "repeat(5,1fr)",
                gap: "1rem",
                marginBottom: "1rem",
              },
            },
            React.createElement(
              "div",
              {
                onClick: () => {
                  setFilterStatus("todos");
                  setSearchTerm("");
                },
                style: {
                  ...styles.card,
                  cursor: "pointer",
                  backgroundColor:
                    filterStatus === "todos"
                      ? colors.gold.light
                      : "rgba(255,255,255,0.95)",
                  border:
                    filterStatus === "todos"
                      ? `2px solid ${colors.gold.primary}`
                      : `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                {
                  style: {
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: colors.gold.dark,
                  },
                },
                stats.total
              ),
              React.createElement("div", null, "Total Clientes")
            ),
            React.createElement(
              "div",
              {
                onClick: () => {
                  setFilterStatus("pendientes");
                  setSearchTerm("");
                },
                style: {
                  ...styles.card,
                  cursor: "pointer",
                  backgroundColor:
                    filterStatus === "pendientes"
                      ? colors.gold.light
                      : "rgba(255,255,255,0.95)",
                  border:
                    filterStatus === "pendientes"
                      ? `2px solid ${colors.gold.primary}`
                      : `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                {
                  style: {
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: colors.gold.dark,
                  },
                },
                stats.pendientes
              ),
              React.createElement("div", null, "⏳ Pendientes")
            ),
            React.createElement(
              "div",
              {
                onClick: () => {
                  setFilterStatus("validados");
                  setSearchTerm("");
                },
                style: {
                  ...styles.card,
                  cursor: "pointer",
                  backgroundColor:
                    filterStatus === "validados"
                      ? colors.gold.light
                      : "rgba(255,255,255,0.95)",
                  border:
                    filterStatus === "validados"
                      ? `2px solid ${colors.gold.primary}`
                      : `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                {
                  style: {
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: "#2C5282",
                  },
                },
                stats.validados
              ),
              React.createElement("div", null, "✅ Validados")
            ),
            React.createElement(
              "div",
              {
                onClick: () => {
                  setFilterStatus("activos");
                  setSearchTerm("");
                },
                style: {
                  ...styles.card,
                  cursor: "pointer",
                  backgroundColor:
                    filterStatus === "activos"
                      ? colors.gold.light
                      : "rgba(255,255,255,0.95)",
                  border:
                    filterStatus === "activos"
                      ? `2px solid ${colors.gold.primary}`
                      : `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                {
                  style: {
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: colors.accent.success,
                  },
                },
                stats.activos
              ),
              React.createElement("div", null, "🟢 Activos")
            ),
            React.createElement(
              "div",
              {
                onClick: () => {
                  setFilterStatus("finalizados");
                  setSearchTerm("");
                },
                style: {
                  ...styles.card,
                  cursor: "pointer",
                  backgroundColor:
                    filterStatus === "finalizados"
                      ? colors.gold.light
                      : "rgba(255,255,255,0.95)",
                  border:
                    filterStatus === "finalizados"
                      ? `2px solid ${colors.gold.primary}`
                      : `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                {
                  style: {
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: colors.gray.text,
                  },
                },
                stats.finalizados
              ),
              React.createElement("div", null, "🏁 Finalizados")
            )
          ),

          React.createElement(
            "div",
            { style: { marginBottom: "1rem" } },
            React.createElement("input", {
              type: "text",
              placeholder: "🔍 Buscar por nombre, cédula o teléfono...",
              value: searchTerm,
              onChange: (e) => setSearchTerm(e.target.value),
              style: styles.input,
            })
          ),

          filterStatus !== "todos" &&
            React.createElement(
              "div",
              {
                style: {
                  marginBottom: "1rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                },
              },
              React.createElement(
                "span",
                {
                  style: {
                    backgroundColor: colors.gold.light,
                    padding: "0.25rem 0.75rem",
                    borderRadius: "2rem",
                    fontSize: "0.75rem",
                    color: colors.gold.dark,
                  },
                },
                "Filtro activo:"
              ),
              React.createElement(
                "span",
                { style: { fontWeight: "bold", color: colors.gold.dark } },
                filterStatus === "pendientes"
                  ? "⏳ Pendientes"
                  : filterStatus === "validados"
                  ? "✅ Validados"
                  : filterStatus === "activos"
                  ? "🟢 Activos"
                  : "🏁 Finalizados"
              ),
              React.createElement(
                "button",
                {
                  onClick: () => {
                    setFilterStatus("todos");
                    setSearchTerm("");
                  },
                  style: {
                    ...styles.buttonOutline,
                    padding: "0.25rem 0.75rem",
                    fontSize: "0.75rem",
                  },
                },
                "Limpiar filtro"
              )
            ),

          React.createElement(
            "div",
            {
              style: {
                display: "grid",
                gridTemplateColumns: "300px 1fr",
                gap: "1rem",
              },
            },
            React.createElement(
              "div",
              {
                style: {
                  ...styles.card,
                  maxHeight: "500px",
                  overflowY: "auto",
                },
              },
              filteredRecords.length === 0
                ? React.createElement(
                    "p",
                    {
                      style: {
                        textAlign: "center",
                        padding: "2rem",
                        color: colors.gray.text,
                      },
                    },
                    filterStatus !== "todos"
                      ? `No hay clientes ${
                          filterStatus === "pendientes"
                            ? "pendientes"
                            : filterStatus === "validados"
                            ? "validados"
                            : filterStatus === "activos"
                            ? "activos"
                            : "finalizados"
                        }`
                      : "No hay clientes registrados"
                  )
                : filteredRecords.map((r) =>
                    React.createElement(
                      "div",
                      {
                        key: r.id,
                        onClick: () => setSelectedRecord(r),
                        style: {
                          padding: "0.75rem",
                          borderBottom: `1px solid ${colors.gray.warm}`,
                          cursor: "pointer",
                          backgroundColor:
                            selectedRecord?.id === r.id
                              ? colors.gold.light
                              : "transparent",
                        },
                      },
                      React.createElement(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            color: colors.gold.dark,
                          },
                        },
                        r.form.nombre || "Cliente"
                      ),
                      React.createElement(
                        "div",
                        {
                          style: {
                            fontSize: "0.75rem",
                            color: colors.gray.text,
                          },
                        },
                        r.form.cedula
                      ),
                      React.createElement(
                        "span",
                        {
                          style: {
                            ...styles.badge,
                            ...getClientStatus(r).badgeStyle,
                          },
                        },
                        getClientStatus(r).icon,
                        " ",
                        getClientStatus(r).label
                      )
                    )
                  )
            ),
            React.createElement(
              "div",
              { style: styles.card },
              selectedRecord
                ? React.createElement(RecordDetailView, {
                    user,
                    record: selectedRecord,
                    onUpdate: (u) => {
                      setRecords(records.map((r) => (r.id === u.id ? u : r)));
                      setSelectedRecord(u);
                    },
                  })
                : React.createElement(
                    "div",
                    {
                      style: {
                        textAlign: "center",
                        padding: "3rem",
                        color: colors.gray.text,
                      },
                    },
                    "👈 Selecciona un cliente"
                  )
            )
          )
        ),
      activeTab === "reportes" &&
        React.createElement(ReportsPanel, { records }),
      activeTab === "usuarios" &&
        canManageUsers &&
        React.createElement(UserManagement, {
          users,
          setUsers,
          currentUser: user,
        })
    )
  );
}

function TreatmentSelectionStep({ form, setForm }) {
  return React.createElement(
    "div",
    null,
    React.createElement(SectionTitle, { title: "Selecciona tu tratamiento" }),
    React.createElement(
      "div",
      {
        style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" },
      },
      ["Facial", "Corporal"].map((item) =>
        React.createElement(
          "button",
          {
            key: item,
            onClick: () => setForm({ ...form, treatmentType: item }),
            style: {
              borderRadius: "1rem",
              border:
                form.treatmentType === item
                  ? `2px solid ${colors.gold.primary}`
                  : `1px solid ${colors.gray.medium}`,
              padding: "1rem",
              backgroundColor:
                form.treatmentType === item ? colors.gold.light : "white",
              cursor: "pointer",
              transition: "all 0.2s",
            },
          },
          item
        )
      )
    )
  );
}

function ClientStep({ form, setForm }) {
  const handleCedula = (v) => setForm({ ...form, cedula: onlyNumbers(v) });
  const handleTelefono = (v) => setForm({ ...form, telefono: onlyNumbers(v) });

  return React.createElement(
    "div",
    null,
    React.createElement(SectionTitle, {
      title: "Información del cliente",
      subtitle: "Todos los campos son obligatorios",
    }),
    React.createElement(
      "div",
      { style: styles.gridContainer },
      React.createElement(Field, {
        labelText: "Nombre completo",
        value: form.nombre,
        onChange: (v) => setForm({ ...form, nombre: v }),
        required: true,
      }),
      React.createElement(Field, {
        labelText: "Cédula",
        value: form.cedula,
        onChange: handleCedula,
        type: "tel",
        inputMode: "numeric",
        required: true,
      }),
      React.createElement(DateField, {
        labelText: "Fecha de nacimiento",
        value: form.fechaNacimiento,
        onChange: (v) => setForm({ ...form, fechaNacimiento: v }),
        required: true,
      }),
      React.createElement(Field, {
        labelText: "Edad",
        value: form.edad,
        onChange: () => {},
        disabled: true,
      }),
      React.createElement(SelectField, {
        labelText: "Género",
        value: form.genero,
        onChange: (v) => setForm({ ...form, genero: v }),
        options: ["", "Femenino", "Masculino"],
        required: true,
      }),
      React.createElement(Field, {
        labelText: "Profesión",
        value: form.profesion,
        onChange: (v) => setForm({ ...form, profesion: v }),
        required: true,
      }),
      React.createElement(Field, {
        labelText: "Correo electrónico",
        value: form.correo,
        onChange: (v) => setForm({ ...form, correo: v }),
        type: "email",
        required: true,
      }),
      React.createElement(Field, {
        labelText: "Teléfono",
        value: form.telefono,
        onChange: handleTelefono,
        type: "tel",
        inputMode: "numeric",
        required: true,
      })
    ),
    React.createElement(Field, {
      labelText: "Dirección",
      value: form.direccion,
      onChange: (v) => setForm({ ...form, direccion: v }),
      required: true,
    })
  );
}

function EmergencyStep({ form, setForm }) {
  const handleTelefono = (v) =>
    setForm({ ...form, emergenciaTelefono: onlyNumbers(v) });

  return React.createElement(
    "div",
    null,
    React.createElement(SectionTitle, {
      title: "Contacto de emergencia",
      subtitle: "Todos los campos son obligatorios",
    }),
    React.createElement(
      "div",
      { style: styles.gridContainer },
      React.createElement(Field, {
        labelText: "Nombre completo",
        value: form.emergenciaNombre,
        onChange: (v) => setForm({ ...form, emergenciaNombre: v }),
        required: true,
      }),
      React.createElement(Field, {
        labelText: "Teléfono",
        value: form.emergenciaTelefono,
        onChange: handleTelefono,
        type: "tel",
        inputMode: "numeric",
        required: true,
      }),
      React.createElement(Field, {
        labelText: "Correo electrónico",
        value: form.emergenciaCorreo,
        onChange: (v) => setForm({ ...form, emergenciaCorreo: v }),
        type: "email",
        required: true,
      }),
      React.createElement(Field, {
        labelText: "Relación",
        value: form.emergenciaRelacion,
        onChange: (v) => setForm({ ...form, emergenciaRelacion: v }),
        required: true,
      })
    )
  );
}

function TreatmentDetailStep({ form, setForm }) {
  if (form.treatmentType === "Facial") {
    return React.createElement(TextAreaField, {
      labelText:
        "¿Qué tratamiento facial le interesa? ¿Cuál es su preocupación principal? ¿Qué objetivo busca?",
      value: form.facialText,
      onChange: (v) => setForm({ ...form, facialText: v }),
      required: true,
      placeholder:
        "Ejemplo: Tratamiento para el acné, me preocupan las marcas y quiero mejorar la textura de mi piel.",
      rows: 4,
    });
  }
  return React.createElement(
    "div",
    null,
    React.createElement(
      "div",
      {
        style: {
          display: "grid",
          gridTemplateColumns: "repeat(3,1fr)",
          gap: "0.5rem",
          marginBottom: "1rem",
        },
      },
      bodyCategories.map((cat) =>
        React.createElement(
          "button",
          {
            key: cat,
            onClick: () =>
              setForm({
                ...form,
                bodyCategory: cat,
                moldeoText: "",
                laserText: "",
                massageText: "",
              }),
            style: {
              padding: "0.5rem",
              borderRadius: "1rem",
              border:
                form.bodyCategory === cat
                  ? `2px solid ${colors.gold.primary}`
                  : `1px solid ${colors.gray.medium}`,
              backgroundColor:
                form.bodyCategory === cat ? colors.gold.light : "white",
              cursor: "pointer",
            },
          },
          cat
        )
      )
    ),
    form.bodyCategory === "Moldeo corporal" &&
      React.createElement(TextAreaField, {
        labelText:
          "¿Qué áreas desea tratar? ¿Cuál es su preocupación principal? ¿Qué objetivo busca?",
        value: form.moldeoText,
        onChange: (v) => setForm({ ...form, moldeoText: v }),
        required: true,
        placeholder:
          "Ejemplo: Abdomen, glúteos, celulitis en piernas, quiero reducir medidas y mejorar la apariencia.",
        rows: 4,
      }),
    form.bodyCategory === "Depilación láser" &&
      React.createElement(TextAreaField, {
        labelText: "¿Qué zonas desea depilar? ¿Cuál es su preocupación?",
        value: form.laserText,
        onChange: (v) => setForm({ ...form, laserText: v }),
        required: true,
        placeholder:
          "Ejemplo: Axilas, piernas completas, bigote, quiero un resultado permanente.",
        rows: 4,
      }),
    form.bodyCategory === "Masajes" &&
      React.createElement(TextAreaField, {
        labelText:
          "¿Qué tipo de masaje desea? ¿Cuál es su molestia o preocupación? ¿Qué objetivo busca?",
        value: form.massageText,
        onChange: (v) => setForm({ ...form, massageText: v }),
        required: true,
        placeholder:
          "Ejemplo: Masaje descontracturante para dolor de espalda, busco alivio y relajación.",
        rows: 4,
      })
  );
}

function MedicalStep({ form, setForm }) {
  const showAnticonceptivos = form.genero === "Femenino";

  return React.createElement(
    "div",
    null,
    React.createElement(SectionTitle, { title: "Información médica" }),
    React.createElement(
      "div",
      {
        style: {
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "0.75rem",
        },
      },
      medicalOptions.map((item) =>
        React.createElement(
          "label",
          {
            key: item,
            style: {
              borderRadius: "1rem",
              border: `1px solid ${colors.gray.medium}`,
              padding: "1rem",
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
              backgroundColor: "white",
            },
          },
          React.createElement("input", {
            type: "checkbox",
            checked: form.medical.includes(item),
            onChange: () =>
              setForm({ ...form, medical: toggleArray(item, form.medical) }),
          }),
          React.createElement("span", null, item)
        )
      )
    ),
    React.createElement(
      "div",
      { style: styles.gridContainer },
      React.createElement(SelectField, {
        labelText: "¿Está tomando actualmente algún medicamento?",
        value: form.medicamentosActuales,
        onChange: (v) => setForm({ ...form, medicamentosActuales: v }),
        options: ["", "Sí", "No"],
        required: true,
      }),
      React.createElement(Field, {
        labelText: "Si sí, ¿cuál(es)?",
        value: form.medicamentosCuales,
        onChange: (v) => setForm({ ...form, medicamentosCuales: v }),
      }),
      showAnticonceptivos &&
        React.createElement(SelectField, {
          labelText: "¿Usa anticonceptivos?",
          value: form.anticonceptivos,
          onChange: (v) => setForm({ ...form, anticonceptivos: v }),
          options: ["", "Sí", "No"],
          required: true,
        }),
      showAnticonceptivos &&
        React.createElement(Field, {
          labelText: "Anticonceptivos: ¿Qué tipo?",
          value: form.anticonceptivosCuales,
          onChange: (v) => setForm({ ...form, anticonceptivosCuales: v }),
        }),
      React.createElement(Field, {
        labelText: "Tipo de piel",
        value: form.tipoPiel,
        onChange: (v) => setForm({ ...form, tipoPiel: v }),
      }),
      React.createElement(Field, {
        labelText: "Alergias a ingredientes o productos específicos",
        value: form.alergiasProductos,
        onChange: (v) => setForm({ ...form, alergiasProductos: v }),
      })
    ),
    React.createElement(
      "div",
      { style: styles.gridContainer },
      React.createElement(SelectField, {
        labelText: "Procedimientos estéticos o tratamientos faciales recientes",
        value: form.procedimientosRecientes,
        onChange: (v) =>
          setForm({
            ...form,
            procedimientosRecientes: v,
            procedimientosRecientesCuales: "",
          }),
        options: ["", "Sí", "No"],
      }),
      form.procedimientosRecientes === "Sí" &&
        React.createElement(Field, {
          labelText: "¿Cuáles procedimientos?",
          value: form.procedimientosRecientesCuales,
          onChange: (v) =>
            setForm({ ...form, procedimientosRecientesCuales: v }),
          required: true,
        }),
      React.createElement(Field, {
        labelText: "Otras preocupaciones médicas",
        value: form.otrasPreocupaciones,
        onChange: (v) => setForm({ ...form, otrasPreocupaciones: v }),
      })
    ),
    React.createElement(
      "div",
      { style: { marginTop: "1rem" } },
      React.createElement(SelectField, {
        labelText: "Autorizo a utilizar mi imagen para fotos y videos",
        value: form.autorizaImagen,
        onChange: (v) => setForm({ ...form, autorizaImagen: v }),
        options: ["", "Sí", "No"],
        required: true,
      })
    )
  );
}

function ConsentStep({ form, setForm }) {
  const formattedConsentBody = consentBody.split("\n").map((line, i) => {
    if (
      line.startsWith("Información importante") ||
      line.startsWith("Riesgos") ||
      line.startsWith("Recomendaciones") ||
      line.startsWith("Declaración")
    ) {
      return React.createElement(
        "div",
        {
          key: i,
          style: {
            fontWeight: "bold",
            marginTop: "0.75rem",
            marginBottom: "0.25rem",
            color: colors.gold.dark,
          },
        },
        line
      );
    }
    if (line.trim() === "")
      return React.createElement("div", {
        key: i,
        style: { height: "0.5rem" },
      });
    return React.createElement("div", { key: i }, line);
  });

  return React.createElement(
    "div",
    null,
    React.createElement(SectionTitle, { title: "Consentimiento informado" }),
    React.createElement(
      "div",
      {
        style: {
          borderRadius: "1.5rem",
          border: `1px solid ${colors.gold.light}`,
          backgroundColor: colors.light.background,
          padding: "1.25rem",
          minHeight: "320px",
          whiteSpace: "pre-wrap",
          lineHeight: "1.75",
          color: colors.dark.primary,
        },
      },
      React.createElement(
        "div",
        {
          style: {
            fontWeight: "bold",
            marginBottom: "1rem",
            color: colors.gold.dark,
          },
        },
        "Procedimiento"
      ),
      React.createElement(
        "div",
        { style: { marginBottom: "1.25rem" } },
        treatmentProcedureText
      ),
      formattedConsentBody
    ),
    React.createElement(
      "label",
      {
        style: {
          marginTop: "1.25rem",
          display: "flex",
          alignItems: "center",
          gap: "0.75rem",
          borderRadius: "1rem",
          border: `1px solid ${colors.gold.light}`,
          padding: "1rem",
          backgroundColor: "white",
        },
      },
      React.createElement("input", {
        type: "checkbox",
        checked: form.aceptaConsentimiento,
        onChange: (e) =>
          setForm({ ...form, aceptaConsentimiento: e.target.checked }),
      }),
      "He leído y acepto el consentimiento informado."
    )
  );
}

function SignatureStep({ form, setForm }) {
  return React.createElement(
    "div",
    null,
    React.createElement(SectionTitle, { title: "Firma del cliente" }),
    React.createElement(
      "div",
      { style: styles.gridContainer },
      React.createElement(Field, {
        labelText: "Firma del cliente (nombre completo)",
        value: form.firmaCliente,
        onChange: (v) => setForm({ ...form, firmaCliente: v }),
        required: true,
        placeholder: "Nombre y apellido completo",
      }),
      React.createElement(
        "div",
        null,
        React.createElement(
          "label",
          {
            style: {
              fontWeight: "500",
              display: "block",
              marginBottom: "0.5rem",
              color: colors.gold.dark,
            },
          },
          "Fecha"
        ),
        React.createElement(
          "div",
          { style: { ...styles.input, backgroundColor: colors.gray.warm } },
          formatDateCR(new Date().toISOString().slice(0, 10))
        )
      )
    )
  );
}

function IntakeWizard({ onSubmit, existingRecords, onExit }) {
  const [form, setForm] = useState(initialForm);
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState([]);
  const [showExit, setShowExit] = useState(false);

  useEffect(() => {
    setForm((f) => ({ ...f, edad: calcAge(f.fechaNacimiento) }));
  }, [form.fechaNacimiento]);

  const isCedulaUnique = (ced) =>
    !existingRecords.some((r) => r.form.cedula === ced);
  const steps = [
    "Tratamiento",
    "Cliente",
    "Emergencia",
    "Detalle",
    "Médica",
    "Consentimiento",
    "Firma",
  ];

  const validateStep = () => {
    const errs = [];

    if (step === 1) {
      if (!form.nombre.trim()) errs.push("Nombre completo es obligatorio.");
      if (!hasFirstAndLastName(form.nombre))
        errs.push(
          "Debe ingresar nombre y apellido completo (mínimo dos palabras)."
        );
      if (!form.cedula.trim()) errs.push("Cédula es obligatoria.");
      if (form.cedula && !/^\d+$/.test(form.cedula))
        errs.push("Cédula debe contener solo números.");
      if (!isCedulaUnique(form.cedula))
        errs.push("❌ Esta cédula ya está registrada. Por favor verifique.");
      if (!form.fechaNacimiento)
        errs.push("Fecha de nacimiento es obligatoria.");
      if (!isValidBirthYear(form.fechaNacimiento))
        errs.push(
          "El año de nacimiento no es válido. Debe comenzar con 1 o 2 y tener 4 dígitos."
        );
      if (!isValidBirthDate(form.fechaNacimiento))
        errs.push("La edad no puede ser mayor a 100 años.");
      if (!form.genero)
        errs.push(
          "Debes seleccionar si te identificas como femenino o masculino."
        );
      if (!form.profesion.trim()) errs.push("Profesión es obligatoria.");
      if (!form.correo.trim()) errs.push("Correo electrónico es obligatorio.");
      if (!isValidEmail(form.correo))
        errs.push(
          "El correo electrónico no es válido. Debe incluir @ y un dominio."
        );
      if (!form.telefono.trim()) errs.push("Teléfono es obligatorio.");
      if (form.telefono && !/^\d+$/.test(form.telefono))
        errs.push("Teléfono debe contener solo números.");
      if (!form.direccion.trim()) errs.push("Dirección es obligatoria.");
    }

    if (step === 2) {
      if (!form.emergenciaNombre.trim())
        errs.push("Nombre de contacto de emergencia es obligatorio.");
      if (!hasFirstAndLastName(form.emergenciaNombre))
        errs.push(
          "Debe ingresar nombre y apellido completo del contacto de emergencia."
        );
      if (!form.emergenciaTelefono.trim())
        errs.push("Teléfono de emergencia es obligatorio.");
      if (form.emergenciaTelefono && !/^\d+$/.test(form.emergenciaTelefono))
        errs.push("Teléfono de emergencia debe contener solo números.");
      if (!form.emergenciaCorreo.trim())
        errs.push("Correo electrónico de emergencia es obligatorio.");
      if (!isValidEmail(form.emergenciaCorreo))
        errs.push("El correo electrónico de emergencia no es válido.");
      if (!form.emergenciaRelacion.trim())
        errs.push("Relación de emergencia es obligatoria.");
    }

    if (step === 3) {
      if (form.treatmentType === "Facial" && !form.facialText.trim())
        errs.push("Por favor describa el tratamiento facial que le interesa.");
      if (form.treatmentType === "Corporal") {
        if (!form.bodyCategory)
          errs.push("Debes seleccionar una categoría corporal.");
        if (form.bodyCategory === "Moldeo corporal" && !form.moldeoText.trim())
          errs.push("Por favor indique qué áreas desea tratar.");
        if (form.bodyCategory === "Depilación láser" && !form.laserText.trim())
          errs.push("Por favor indique las zonas que desea depilar.");
        if (form.bodyCategory === "Masajes" && !form.massageText.trim())
          errs.push("Por favor indique qué tipo de masaje desea.");
      }
    }

    if (step === 4) {
      if (!form.medicamentosActuales)
        errs.push(
          "Debe indicar si está tomando actualmente algún medicamento."
        );
      if (form.medicamentosActuales === "Sí" && !form.medicamentosCuales.trim())
        errs.push("Debes indicar cuáles medicamentos tomas actualmente.");
      if (form.genero === "Femenino") {
        if (!form.anticonceptivos)
          errs.push("Debes indicar si usas anticonceptivos.");
        if (form.anticonceptivos === "Sí" && !form.anticonceptivosCuales.trim())
          errs.push("Debes indicar qué tipo de anticonceptivos usas.");
      }
      if (
        form.procedimientosRecientes === "Sí" &&
        !form.procedimientosRecientesCuales.trim()
      )
        errs.push("Debes indicar cuáles procedimientos estéticos has tenido.");
      if (!form.autorizaImagen)
        errs.push("Debes indicar si autorizas o no el uso de tu imagen.");
    }

    if (step === 5) {
      if (!form.aceptaConsentimiento)
        errs.push("Debes aceptar el consentimiento informado para continuar.");
    }

    if (step === 6) {
      if (!form.firmaCliente.trim())
        errs.push("La firma del cliente es obligatoria.");
      if (!hasFirstAndLastName(form.firmaCliente))
        errs.push("La firma debe incluir nombre y apellido completo.");
    }

    setErrors(errs);
    return errs.length === 0;
  };

  const next = () => {
    if (!validateStep()) return;
    setStep((s) => Math.min(s + 1, steps.length - 1));
  };

  const back = () => setStep((s) => Math.max(s - 1, 0));

  const submit = () => {
    if (!validateStep()) return;

    if (!isCedulaUnique(form.cedula)) {
      setErrors(["❌ Esta cédula ya está registrada. Por favor verifique."]);
      return;
    }

    const record = {
      id: crypto.randomUUID(),
      status: "pendiente_revision",
      createdAt: new Date().toISOString(),
      form,
      specialistReview: null,
      sessions: [],
      treatmentPlan: null,
      changeHistory: [],
      notes: [],
    };
    onSubmit(record);
  };

  const treatmentDisplay = form.treatmentType
    ? React.createElement(
        "div",
        { style: styles.selectedTreatmentBadge },
        "Tratamiento seleccionado: ",
        form.treatmentType === "Facial" ? "💆‍♀️ Facial" : "💪 Corporal"
      )
    : null;

  return React.createElement(
    "div",
    { style: { ...styles.container, position: "relative" } },
    React.createElement(
      "button",
      { onClick: () => setShowExit(true), style: styles.exitButton },
      "✖️ Salir"
    ),
    showExit &&
      React.createElement(
        "div",
        {
          style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          },
        },
        React.createElement(
          "div",
          {
            style: {
              backgroundColor: "white",
              borderRadius: "1.5rem",
              padding: "2rem",
              maxWidth: "400px",
              textAlign: "center",
            },
          },
          React.createElement(
            "h3",
            { style: { color: colors.gold.dark } },
            "¿Salir del registro?"
          ),
          React.createElement("p", null, "Perderás todo el progreso."),
          React.createElement(
            "div",
            {
              style: {
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
                marginTop: "1rem",
              },
            },
            React.createElement(
              "button",
              {
                onClick: () => setShowExit(false),
                style: styles.buttonOutline,
              },
              "Continuar"
            ),
            React.createElement(
              "button",
              {
                onClick: () => {
                  setShowExit(false);
                  onExit();
                },
                style: styles.buttonDanger,
              },
              "Sí, salir"
            )
          )
        )
      ),
    React.createElement(
      "div",
      { style: { maxWidth: "56rem", margin: "0 auto" } },
      treatmentDisplay,
      React.createElement(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1.5rem",
          },
        },
        React.createElement(
          "div",
          null,
          React.createElement(
            "div",
            { style: { fontSize: "0.875rem", color: colors.gray.text } },
            BRAND.subtitle
          ),
          React.createElement(
            "h1",
            {
              style: {
                fontSize: "1.875rem",
                fontFamily: "Georgia, serif",
                color: colors.gold.dark,
              },
            },
            BRAND.name
          )
        ),
        React.createElement(
          "div",
          { style: { fontSize: "0.875rem", color: colors.gray.text } },
          "Paso ",
          step + 1,
          " de ",
          steps.length
        )
      ),
      React.createElement(
        "div",
        { style: styles.card },
        errors.length > 0 &&
          React.createElement(
            "div",
            { style: styles.errorBox },
            React.createElement(
              "div",
              { style: { fontWeight: "bold", marginBottom: "0.5rem" } },
              "Completa lo siguiente para continuar:"
            ),
            React.createElement(
              "ul",
              { style: { paddingLeft: "1.25rem", margin: 0 } },
              errors.map((err, idx) =>
                React.createElement(
                  "li",
                  { key: idx, style: { marginBottom: "0.25rem" } },
                  err
                )
              )
            )
          ),
        step === 0 &&
          React.createElement(TreatmentSelectionStep, { form, setForm }),
        step === 1 && React.createElement(ClientStep, { form, setForm }),
        step === 2 && React.createElement(EmergencyStep, { form, setForm }),
        step === 3 &&
          form.treatmentType &&
          React.createElement(TreatmentDetailStep, { form, setForm }),
        step === 4 && React.createElement(MedicalStep, { form, setForm }),
        step === 5 && React.createElement(ConsentStep, { form, setForm }),
        step === 6 && React.createElement(SignatureStep, { form, setForm }),
        React.createElement(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              marginTop: "2rem",
            },
          },
          React.createElement(
            "button",
            {
              onClick: back,
              disabled: step === 0,
              style: {
                borderRadius: "1rem",
                border: `1px solid ${colors.gray.medium}`,
                padding: "0.75rem 1.25rem",
                backgroundColor: "white",
                cursor: step === 0 ? "not-allowed" : "pointer",
                opacity: step === 0 ? 0.4 : 1,
              },
            },
            "← Atrás"
          ),
          step < steps.length - 1
            ? React.createElement(
                "button",
                { onClick: next, style: styles.button },
                "Siguiente →"
              )
            : React.createElement(
                "button",
                {
                  onClick: submit,
                  style: {
                    backgroundColor: colors.accent.success,
                    ...styles.button,
                    padding: "0.75rem 1.25rem",
                  },
                },
                "Guardar ✓"
              )
        )
      )
    )
  );
}

export default function ExperienciaNilaApp() {
  const [view, setView] = useState("home");
  const [records, setRecords] = useState(() => loadLS("nila_records", []));
  const [user, setUser] = useState(() => loadLS("nila_user", null));

  useEffect(() => saveLS("nila_records", records), [records]);
  useEffect(() => saveLS("nila_user", user), [user]);

  if (view === "home")
    return React.createElement(WelcomeScreen, {
      onStart: () => setView("intake"),
      onLoginClick: () => setView("login"),
    });
  if (view === "intake")
    return React.createElement(IntakeWizard, {
      onSubmit: (r) => {
        setRecords([r, ...records]);
        setView("thankyou");
      },
      existingRecords: records,
      onExit: () => setView("home"),
    });
  if (view === "thankyou")
    return React.createElement(
      "div",
      { style: styles.container },
      React.createElement(
        "div",
        {
          style: {
            maxWidth: "36rem",
            margin: "0 auto",
            ...styles.card,
            textAlign: "center",
          },
        },
        React.createElement(
          "div",
          {
            style: {
              fontSize: "3rem",
              marginBottom: "1rem",
              color: colors.accent.success,
            },
          },
          "✓"
        ),
        React.createElement(
          "h1",
          {
            style: {
              fontSize: "2.25rem",
              fontFamily: "Georgia, serif",
              marginBottom: "0.75rem",
              color: colors.gold.dark,
            },
          },
          "Gracias por completar tu Experiencia Nila"
        ),
        React.createElement(
          "p",
          { style: { color: colors.gray.text, marginBottom: "1.5rem" } },
          "Tu información ha sido registrada correctamente."
        ),
        React.createElement(
          "div",
          {
            style: {
              display: "flex",
              gap: "0.75rem",
              justifyContent: "center",
            },
          },
          React.createElement(
            "button",
            {
              onClick: () => setView("home"),
              style: {
                borderRadius: "1rem",
                border: `1px solid ${colors.gray.medium}`,
                padding: "0.75rem 1.25rem",
                backgroundColor: "white",
                cursor: "pointer",
              },
            },
            "Volver al inicio"
          ),
          React.createElement(
            "button",
            { onClick: () => setView("login"), style: styles.buttonSecondary },
            "Acceso interno"
          )
        )
      )
    );
  if (view === "login")
    return React.createElement(LoginPanel, {
      onLogin: (u) => {
        setUser(u);
        setView("dashboard");
      },
      onBack: () => setView("home"),
    });
  return React.createElement(Dashboard, {
    user,
    records,
    setRecords,
    onLogout: () => {
      setUser(null);
      setView("home");
    },
  });
}

